import React, { useState, useRef, useEffect, useContext } from "react";
import "../../css/PropertyDetail.css";
import mask from "../../images/Mask group.png";
import emi from "../../images/emi.png";
import zoom from "../../images/zoom.png";
import affordable from "../../images/affordable.png";
import property_value from "../../images/property_value.png";
import eligibility from "../../images/eligibility.png";
import no_image from "../../images/no_avilable.png";
import seller from "../../images/seller1.jpg";
import sink from "../../images/Project Specifications/sink.gif";
import tile from "../../images/Project Specifications/tile.gif";
import wall from "../../images/Project Specifications/wall.gif";
import { useLocation } from "react-router-dom";
import { Line, Doughnut } from "react-chartjs-2";
import { fetchProfileProperties } from "../../redux/profilePropertySlice";
import { useDispatch, useSelector } from "react-redux";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import "chart.js/auto";
import axios from "axios";
import ImageModal from "../modals/ImageModal";
import { showPrice } from "../../utils/showPrice";
import { avgPrice } from "../../utils/avgPrice";
import { AppContext } from "../../context/AppContext";
import PlanCarosuel from "../PlanCarosuel";
import VideoModal from "../modals/VideoModal";
import AboutDeveloper from "../pages/AboutDeveloper";
import PropertyFaq from "../faq/PropertyFaq";
import Disclaimer from "../Disclaimer";
import EMICalculator from "../calculator/EMICalculator";
import ContactModal from "../modals/contactModal";
import { eventEmitter } from "../EventEmitter";
import config from "../../config/config";
import dummyImg from "../../images/no-image-thumb.jpg";
import { useNavigate } from "react-router-dom";
import {
  downloadFile,
  sendWhatsappMessageApi,
  shortlistedPropertyApi,
} from "../../api/commonApi";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AlertModal from "../modals/AlertModal";
import generateSlug from "../common/generateSlug";
import { Helmet } from "react-helmet";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

// Custom Next Arrow
const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="pdNextArrow" onClick={onClick}>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.4258 19.4129L17.8258 15.0004L13.4258 10.5879"
          stroke="#343434"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

// Custom Prev Arrow
const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="pdPrevArrow" onClick={onClick}>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.5742 10.5871L12.1742 14.9996L16.5742 19.4121"
          stroke="#343434"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

const PropertyDetail = () => {
  const theme = { primary: "#fff", secondary: "none", default: "#343434" };
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;
  const pathSegments = path.split("/").filter(Boolean); // removes empty segments
  useEffect(() => {
    if (pathSegments.length === 0) {
      console.log("❌ Empty path");
      return;
    }

    const lastSegment = pathSegments[pathSegments.length - 1];

    // Pattern to match -rid- or -pid- followed by one or more digits
    const slugPattern = /-(rid|pid)-(\d+)$/i;

    const match = lastSegment.match(slugPattern);

    if (match) {
      const id = match[2]; // This will be the digits after -rid- or -pid-
      if (id && !isNaN(id)) {
        console.log(`✅ Matched: ${match[1]} with ID ${id}`);
      } else {
        console.log("❌ Invalid or missing ID after -rid- or -pid-");
        navigate("/not_found");
      }
    } else {
      console.log("❌ Unknown URL pattern");
      navigate("/not_found");
    }
  }, [path]);

  const [isWishlisted, setIsWishlisted] = useState(false);

  const token = config.getAuthToken();
  const [showModal, setShowModal] = useState(false);
  const [contactMobile, setContactMobile] = useState("");
  const [selectedProject, setSelectedProject] = useState(null);
  const [contactedId, setContactedId] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [viewId, setViewId] = useState([]);
  const { user } = useContext(AppContext);
  const [list, setList] = useState([]);

  const dispatch = useDispatch();

  const { properties, status, error1 } = useSelector(
    (state) => state.profileProperty
  );

  useEffect(() => {
    if (properties?.contacted) {
      setContactedId(properties.contacted.map(Number)); // Convert to integers
    }
    if (properties?.viewed) {
      setViewId(properties.viewed.map(Number)); // Convert to integers
    }
    if (properties?.wishlist) {
      setWishlist(properties.wishlist.map(Number)); // Convert to integers
    }
  }, [properties]);
  useEffect(() => {
    if (properties?.wishlist && list) {
      let propertyIds = [];

      if (Array.isArray(list?.property_ids)) {
        propertyIds = list.property_ids.map(String);
      } else if (Array.isArray(list?.[0]?.property_ids)) {
        propertyIds = list[0].property_ids.map(String);
      } else {
        const raw = list?.property_ids || list?.[0]?.property_ids || "";
        propertyIds = String(raw)
          .split(",")
          .map((id) => id.trim())
          .filter((id) => id); // remove empty strings
      }

      const wishlistStr = wishlist.map(String);
      const isWishlistedNow = wishlistStr.some((value) =>
        propertyIds.includes(value)
      );

      console.log("wishlist:", wishlistStr);
      console.log("propertyIds:", propertyIds);
      console.log("isWishlistedNow:", isWishlistedNow);

      setIsWishlisted(isWishlistedNow);
    }
  }, [wishlist, list]);
  const getImagePath = (label, extension) => {
    try {
      return require(`../../images/icons/${label.toLowerCase()}.${extension}`);
    } catch (error) {
      return "/images/icons/default.svg"; // Fallback image
    }
  };

  const [iframe, setIframe] = useState(false);
  const [videLink, setVideoLink] = useState("");

  const playVideo = (link) => {
    setIframe(true);
    setVideoLink(link);
  };
  const closeModal = () => {
    setIframe(false);
    setVideoLink("");
  };

  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openImageModal = () => {
    setIsImageModalOpen(true);
  };
  // Function to close the Tip Modal
  const handleImagesModalClose = () => {
    setIsImageModalOpen(false);
  };

  const [selectedSection, setSelectedSection] = useState("overview-section");

  const containerRef = useRef(null); // Reference to the scrollable div

  const scrollToContainer = () => {
    const scrollContainer = document.getElementById("scroll-container");

    if (scrollContainer) {
      scrollContainer.scrollIntoView({
        behavior: "smooth",
        block: "start", // Align the scrollContainer to the top of the viewport
      });
    } else {
      console.error("Scroll container not found.");
    }
  };

  // const ScrollToSection = (event, sectionId) => {
  //   event.preventDefault(); // Prevent default anchor behavior

  //   scrollToContainer();
  //   const container = containerRef.current; // The scrollable div
  //   const targetElement = document.getElementById(sectionId); // The section to scroll to

  //   if (container && targetElement) {
  //     // Calculate the position of the section relative to the scroll container
  //     const containerRect = container.getBoundingClientRect();
  //     const targetRect = targetElement.getBoundingClientRect();

  //     // The exact scroll position inside the container
  //     const scrollPosition =
  //       targetRect.top - containerRect.top + container.scrollTop;

  //     console.log(`Scrolling to position: ${scrollPosition}px`); // Debugging log

  //     // Scroll smoothly within the container
  //     container.scrollTo({
  //       top: scrollPosition,
  //       behavior: "smooth",
  //     });

  //     setSelectedSection(sectionId);
  //   } else {
  //     console.error("Section or container not found");
  //   }
  // };

  const ScrollToSection = (event, sectionId) => {
    event.preventDefault();
    const targetElement = document.getElementById(sectionId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
      setSelectedSection(sectionId);
    }
  };

  const emiRef = useRef(null);

  const fullPath = location.pathname;

  // const lastSegment = location.pathname.split("/").pop(); // Get the last part of the URL
  // const parts = lastSegment.split("-"); // Split by "-"

  const pId = location.pathname.split("/").pop().split("-").slice(-2).join("-");
  // const pathSegments = location.pathname.split("-");
  // const secondLastSegment = pathSegments.length > 1 ? pathSegments[pathSegments.length - 2] : null;

  const [activeButton, setActiveButton] = useState("");
  const [activeData, setActiveData] = useState(null);

  // Ensure list exists and has plans before setting state
  useEffect(() => {
    if (list?.plans && list.plans.length > 0) {
      setActiveButton(list.plans[0].label.toLowerCase().replace(/\s/g, ""));
      setActiveData(list.plans[0]);
    }

    handleDispatch();
  }, [list]); // Runs whenever `list` updates

  const handleButtonClick = (label) => {
    setActiveButton(label);
    const selectedData = list?.plans?.find(
      (item) => item.label.toLowerCase().replace(/\s/g, "") === label
    );
    setActiveData(selectedData || null); // Ensure it never crashes
  };

  const sliderRef = useRef(null); // Reference to the slider

  const goToPrevious = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev(); // Move to the previous slide
    }
  };

  const goToNext = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext(); // Move to the next slide
    }
  };

  const settings = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0",
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false, // Hide default arrows
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const data = {
    labels: ["Apr 2024", "Jul 2024", "Oct 2024", "Nov 2024", "Dec 2024"],
    datasets: [
      {
        label: "Price per sq.ft.",
        data: [1100, 2300, 1700, 3400, 2500], // Data points
        borderColor: "rgba(86, 135, 242, 1)",
        backgroundColor: "rgba(86, 135, 242, 0.3)", // Area fill color
        tension: 0.4, // Curve tension
        fill: true, // Enable area fill
      },
    ],
  };
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Price Trend Over Time",
      },
    },
    scales: {
      y: {
        ticks: {
          callback: (value) => `${value}/sq.ft.`,
        },
      },
    },
  };

  // Data for the Donut Chart
  const data1 = {
    labels: [
      "5 Stars", // Orange
      "4 Stars", // Pink
      "3 Stars", // Green
      "2 Stars", // Yellow
      "1 Star", // Purple
    ],
    datasets: [
      {
        label: "Star Ratings",
        data: [40, 30, 15, 10, 5], // Example percentages for segments
        backgroundColor: [
          "#FF8C00", // Orange
          "#FF66FF", // Pink
          "#9ACD32", // Green
          "#FFFF00", // Yellow
          "#B366FF", // Purple
        ],
        borderColor: ["#fff"], // White border for separation
        borderWidth: 2,
      },
    ],
  };
  const options1 = {
    responsive: true,
    plugins: {
      legend: {
        position: "left",
        labels: {
          color: "#000", // Black text for labels
          boxWidth: 15, // Box size for legend
        },
      },
    },
    cutout: "40%", // Makes it a donut chart
  };

  // Utility function to group images into chunks of `chunkSize`
  const chunkArray = (array, chunkSize) => {
    const result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }
    return result;
  };

  const [loading, setLoading] = useState(true);

  const [project, setProject] = useState([]);
  const [allAmenities, setAllAmenities] = useState([]);
  const [allPropertyImage, setAllPropertyImage] = useState([]);
  const [prefix, setPrefix] = useState([]);
  //alert(JSON.stringify(list));

  const openEmiModal = () => {
    setIsModalOpen(true);
  };
  const closeEmiModal = () => {
    setIsModalOpen(false);
  };
  const fetchPropertyData = async (pId) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/listingDetails/${pId}`
      );

      if (response.data.success) {
        //alert(JSON.stringify(response.data.data.properties));
        setList(response.data.data); // Set the property list
        setPrefix(response.data.prefix); // Set the property list
        setProject(response.data.data.project); // Set the project
        setAllAmenities(response.data.data.allAmenities); // Set the project
        setAllPropertyImage(response.data.data.allPropertyImages); // Set the project

        window.history.replaceState({}, "", response.data?.data?.url);
        //console.log(list);

        // viewedProperty();

        // const uniqueTypes = [...new Set(response.data.data.properties.map(item => item.property_type))];
        // setUniquePropertyTypes(uniqueTypes);

        setLoading(false);
      } else {
        setList([]);

        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setList([]);

      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPropertyData(pId);
  }, [user?.data?.id]);
  const hasSent = useRef(false); // must be declared outside useEffect

  useEffect(() => {
    if (list && !hasSent.current) {
      const timer = setTimeout(() => {
        hasSent.current = true;
        viewedProperty();
      }, 2000); // Delay of 500ms

      return () => clearTimeout(timer); // Cleanup in case component unmounts
    }
  }, [list]);

  const viewedProperty = async () => {
    if (!user?.data?.id) {
      return;
    }
    const propertyIds =
      JSON.parse(localStorage.getItem("last-property-seen")) || [];
    try {
      const formData = new FormData();
      formData.append("user_id", user?.data?.id || "");
      formData.append("name", user?.data?.name || "");
      formData.append("mobile", user?.data?.mobile || "");
      formData.append("propertyIds", propertyIds?.id);

      const deviceInfo = await getDeviceDetails(); // Get device details

      // Append device details into FormData
      formData.append("os", deviceInfo.os);
      formData.append("browser", deviceInfo.browser);
      formData.append("userAgent", deviceInfo.userAgent);
      formData.append("ip", deviceInfo.ip || "");
      formData.append("city", deviceInfo.city || "");
      formData.append("region", deviceInfo.region || "");
      formData.append("country", deviceInfo.country || "");

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/viewedProperty/${pId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Response:", response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const getDeviceDetails = async () => {
    const deviceInfo = {
      os: getOS(),
      browser: getBrowser(),
      userAgent: navigator.userAgent,
    };

    try {
      // Get public IP & location
      const { data } = await axios.get("https://api64.ipify.org?format=json");
      deviceInfo.ip = data.ip;

      const locationData = await axios.get(`https://ipapi.co/${data.ip}/json/`);
      deviceInfo.city = locationData.data.city;
      deviceInfo.region = locationData.data.region;
      deviceInfo.country = locationData.data.country_name;
    } catch (error) {
      console.warn("Failed to fetch IP/location:", error);
    }

    return deviceInfo;
  };

  // Function to detect OS
  const getOS = () => {
    const userAgent = navigator.userAgent;
    if (userAgent.includes("Windows")) return "Windows";
    if (userAgent.includes("Mac OS")) return "MacOS";
    if (userAgent.includes("Linux")) return "Linux";
    if (userAgent.includes("Android")) return "Android";
    if (userAgent.includes("iOS")) return "iOS";
    return "Unknown";
  };

  // Function to detect browser
  const getBrowser = () => {
    const userAgent = navigator.userAgent;
    if (userAgent.includes("Chrome")) return "Chrome";
    if (userAgent.includes("Firefox")) return "Firefox";
    if (userAgent.includes("Safari")) return "Safari";
    if (userAgent.includes("Edge")) return "Edge";
    if (userAgent.includes("Opera") || userAgent.includes("OPR"))
      return "Opera";
    return "Unknown";
  };

  const formatPrice = (price) => {
    if (price >= 1_00_00_000) {
      return `${(price / 1_00_00_000).toFixed(2)} CR`; // Convert to Crores
    } else if (price >= 1_00_000) {
      return `${(price / 1_00_000).toFixed(2)} L`; // Convert to Lakhs
    } else if (price >= 1_000) {
      return `${(price / 1_000).toFixed(2)} K`; // Convert to Thousands
    } else {
      return `${price}`; // Return as is for smaller amounts
    }
  };

  const calculateEMI = (principal, years, rate1, rate2) => {
    const monthlyRate = rate1 / (12 * 100); // Monthly interest rate
    const months = years * 12; // Total number of months
    const emi =
      (principal * monthlyRate * Math.pow(1 + monthlyRate, months)) /
      (Math.pow(1 + monthlyRate, months) - 1);

    return emi.toFixed(2);
  };

  const [emiCalculator, setEmiCalculator] = useState(false);

  const openEmiCalculator = () => {
    setEmiCalculator(true);
  };

  const closeEmiCalculator = () => {
    setEmiCalculator(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (emiRef.current && !emiRef.current.contains(event.target)) {
        setEmiCalculator(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleShowModal = (project) => {
    if (!user?.data?.id) {
      eventEmitter.emit("loginFirst", true);
      return;
    }
    setSelectedProject(project);
    setShowModal(true);
    contactedProperty(project);
  };

  const contactedProperty = async (property, isContacted = "true") => {
    try {
      //alert(property.property_ids)
      const formData = new FormData();
      formData.append("property_id", property.property_ids);
      formData.append("user_id", user?.data?.id);
      formData.append("name", user?.data?.name);
      formData.append("email", user?.data?.email);
      formData.append("mobile", user?.data?.mobile);
      formData.append("property_owner_id", property?.user_id);
      formData.append("contacted", 1);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/contactedProperty`, // Replace with your API URL
        formData,
        {
          headers: {
            Authorization: `Bearer ${config.getAuthToken()}`, // Attach Bearer token
            "Content-Type": "application/json", // Set correct content type for file upload
          },
        }
      );

      if (response.status) {
        setContactedId((prevContactedIds) => {
          let propertyIds = [];

          if (Array.isArray(property.property_ids)) {
            // Convert all values to numbers
            propertyIds = property.property_ids.map(Number);
          } else if (typeof property.property_ids === "string") {
            // If it's a comma-separated string, split and convert to numbers
            propertyIds = property.property_ids
              .split(",")
              .map((id) => Number(id.trim()));
          } else if (
            property.property_ids !== undefined &&
            property.property_ids !== null
          ) {
            // Convert single value to a number and wrap in an array
            propertyIds = [Number(property.property_ids)];
          }

          // Merge with previous IDs, ensure uniqueness
          return Array.from(new Set([...prevContactedIds, ...propertyIds]));
        });

        setContactMobile(response.data.contact_detail);
        if (isContacted) {
          await sendWhatsappMessageApi({
            slug: "user_property_contacted",
            mobile: response.data?.contact_detail,
            name: response.data?.name,
            title: response.data?.title,
            location: response.data?.location,
            link: response.data?.link,
            token: token,
            user_mobile: user?.data?.mobile,
            user_name: user?.data?.name,
            user_email: user?.data?.email,
          });
        }
      }
    } catch (error) {
      console.error("Error updating:", error);
      alert("Something Went Wrong. Please try again.");
    }
  };

  const [toggle, setToggle] = useState({
    box1: false,
    box2: false,
    box3: false,
    box4: false,
    box5: false,
    box6: false,
    box7: false,
    box8: false,
  });
  const handleToggle = (boxKey) => {
    setToggle((prev) => ({
      ...prev,
      [boxKey]: !prev[boxKey],
    }));
  };

  const handleShortlist = async (id, status) => {
    const result = await shortlistedPropertyApi({ id, status, user, token });

    if (result?.loginRequired) {
      eventEmitter.emit("loginFirst", true);
      return;
    }

    if (result?.status) {
      handleDispatch();
    } else if (result?.error) {
      alert("Something Went Wrong. Please try again.");
    }
  };

  const handleDispatch = () => {
    if (user?.data?.id != null) {
      dispatch(fetchProfileProperties(user?.data?.id));
    }
  };

  const downloadBrochure = (item) => {
    const fileName = `${item?.project_name || "Brochure"}.pdf`;
    downloadFile(item, fileName);
  };
  // const downloadBrochure = (item) => {

  //   const fileUrl = item; // Make sure this is a full URL (https://...)
  //   const fileName = `Brochure.pdf`;

  //   if (!fileUrl) {
  //     alert("No brochure URL found");
  //     return;
  //   }

  //   const a = document.createElement("a");
  //   a.href = fileUrl;
  //   a.setAttribute("download", fileName);
  //   document.body.appendChild(a);
  //   a.click();
  //   document.body.removeChild(a);
  // };

  // const settings2 = {
  //   dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   nextArrow: <NextArrow />,
  //   prevArrow: <PrevArrow />,
  //   responsive: [
  //     {
  //       breakpoint: 768, // Mobile view
  //       settings2: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //       },
  //     },
  //   ],
  // };

  const settings2 = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 768, // below 768px (mobile)
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true, // keep arrows
        },
      },
    ],
  };

  const [showAlertModal, setShowAlertModal] = useState(false);
  const handleOpenModal = () => {
    setShowAlertModal(true);

    // Auto close after 2 seconds
    setTimeout(() => {
      setShowAlertModal(false);
    }, 1500);
  };

  const sharePropertyLink = async () => {
    const longUrl = `${window.location.origin}${generateSlug(
      list.slug_detail
    )}`;

    try {
      // Step 1: Request backend to save and return short URL
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/saveTinyUrl`,
        {
          original_url: longUrl,
        }
      );

      const shortCode = response.data?.short_code;
      const shortUrl = `${window.location.origin}/${shortCode}`;

      // Step 2: Copy to clipboard
      await navigator.clipboard.writeText(shortUrl);

      // Step 3: Show success alert
      //alert("✅ Short URL copied to clipboard:\n" + shortUrl);
      handleOpenModal();
    } catch (error) {
      console.error("❌ Error generating short URL:", error);
      alert("❌ Failed to generate short URL. Please try again.");
    }
  };

  if (loading) {
    // Render a loading UI while checking the short code
    return <div style={{ minHeight: "100vh" }}></div>;
  }

  function slugToTitle(slug) {
    if (!slug) return "";

    // Remove pid or any trailing identifier like pid-1
    let cleanSlug = slug.replace(/-(pid|rid)-\d+$/, "");

    // Split by hyphen, capitalize each word
    let words = cleanSlug.split("-").map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });

    // Join back and append brand name
    return words.join(" ") + " | Siddhi Ananta";
  }
  return (
    <>
      <Helmet>
        <title>{slugToTitle(list?.url)}</title>
        <meta name="description" content={list?.overview?.description} />
        <meta property="og:title" content={slugToTitle(list?.url)} />
      </Helmet>
      <div className="property_detail propdtlbox">
        <div className="social">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation(); // Prevent div click
              sharePropertyLink(e);
            }}
          >
            <div className="social-btn ">
              <div className="">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.4683 3.33333C11.4683 1.49238 12.9915 0 14.8705 0C16.7495 0 18.2727 1.49238 18.2727 3.33333C18.2727 5.17428 16.7495 6.66667 14.8705 6.66667C13.9217 6.66667 13.0643 6.28596 12.4479 5.67347L7.73809 8.8295C7.78158 9.0425 7.80444 9.2625 7.80444 9.4872C7.80444 9.9322 7.71503 10.3576 7.55306 10.7464L12.7173 14.0858C13.3035 13.6161 14.0534 13.3333 14.8705 13.3333C16.7495 13.3333 18.2727 14.8257 18.2727 16.6667C18.2727 18.5076 16.7495 20 14.8705 20C12.9915 20 11.4683 18.5076 11.4683 16.6667C11.4683 16.1845 11.5731 15.7255 11.7616 15.3111L6.63911 11.9987C6.04156 12.5098 5.25885 12.8205 4.4022 12.8205C2.52322 12.8205 1 11.3281 1 9.4872C1 7.64623 2.52322 6.15385 4.4022 6.15385C5.48268 6.15385 6.4445 6.64725 7.06725 7.41518L11.6318 4.35642C11.5256 4.03359 11.4683 3.6896 11.4683 3.33333Z"
                    fill="white"
                  />
                </svg>
              </div>
              <p className="order ">Share Detail</p>
            </div>
          </a>
          <a
            onClick={() =>
              handleShortlist(list?.property_ids, isWishlisted ? 0 : 1)
            }
          >
            <div className="social-btn ">
              <div className="">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill={isWishlisted ? theme.primary : theme.secondary}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.517 17.3413C10.2337 17.4413 9.76699 17.4413 9.48366 17.3413C7.06699 16.5163 1.66699 13.0747 1.66699 7.24134C1.66699 4.66634 3.74199 2.58301 6.30032 2.58301C7.81699 2.58301 9.15866 3.31634 10.0003 4.44967C10.4285 3.87124 10.9861 3.40111 11.6287 3.07696C12.2712 2.75281 12.9807 2.58364 13.7003 2.58301C16.2587 2.58301 18.3337 4.66634 18.3337 7.24134C18.3337 13.0747 12.9337 16.5163 10.517 17.3413Z"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <p className="order ">
                {isWishlisted ? "Shortlisted" : "Add To Wishlist"}
              </p>
            </div>
          </a>
          <a onClick={(e) => ScrollToSection(e, "calculator-section")}>
            <div className="social-btn ">
              <div className="">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M17.8125 0V20H2.1875V0H17.8125ZM7.1875 15H5.3125V16.875H7.1875V15ZM10.9375 15H9.0625V16.875H10.9375V15ZM14.6875 15H12.8125V16.875H14.6875V15ZM7.1875 11.25H5.3125V13.125H7.1875V11.25ZM10.9375 11.25H9.0625V13.125H10.9375V11.25ZM14.6875 11.25H12.8125V13.125H14.6875V11.25ZM7.1875 7.5H5.3125V9.375H7.1875V7.5ZM10.9375 7.5H9.0625V9.375H10.9375V7.5ZM14.6875 7.5H12.8125V9.375H14.6875V7.5ZM15.9375 1.875H4.0625V5.625H15.9375V1.875Z"
                    fill="white"
                  />
                </svg>
              </div>
              <p className="order">Calculator</p>
            </div>
          </a>

          {list?.brochure && (
            <a onClick={() => downloadBrochure(list?.brochure)}>
              <div className="social-btn ">
                <div className="">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.7963 14.375H13.8047M14.1333 11.75H14.6389C15.4241 11.75 15.8167 11.75 16.1264 11.8832C16.5393 12.0608 16.8674 12.4015 17.0384 12.8303C17.1667 13.1519 17.1667 13.5596 17.1667 14.375C17.1667 15.1904 17.1667 15.5981 17.0384 15.9197C16.8674 16.3485 16.5393 16.6892 16.1264 16.8668C15.8167 17 15.4241 17 14.6389 17H4.52778C3.74258 17 3.34999 17 3.04029 16.8668C2.62738 16.6892 2.29931 16.3485 2.12828 15.9197C2 15.5981 2 15.1904 2 14.375C2 13.5596 2 13.1519 2.12828 12.8303C2.29931 12.4015 2.62738 12.0608 3.04029 11.8832C3.34999 11.75 3.74258 11.75 4.52778 11.75H5.03333M9.58333 12.625V3M9.58333 12.625L7.05556 10M9.58333 12.625L12.1111 10"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <p className="order ">Download Brochure</p>
              </div>
            </a>
          )}
          <a onClick={() => handleShowModal(list)}>
            <div className="social-btn ">
              <div className="">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1663_1114)">
                    <path
                      d="M16.4775 13.7475C16.4775 14.0175 16.4175 14.295 16.29 14.565C16.1625 14.835 15.9975 15.09 15.78 15.33C15.4125 15.735 15.0075 16.0275 14.55 16.215C14.1 16.4025 13.6125 16.5 13.0875 16.5C12.3225 16.5 11.505 16.32 10.6425 15.9525C9.78 15.585 8.9175 15.09 8.0625 14.4675C7.19108 13.8301 6.36877 13.1281 5.6025 12.3675C4.84408 11.604 4.14458 10.7842 3.51 9.915C2.895 9.06 2.4 8.205 2.04 7.3575C1.68 6.5025 1.5 5.685 1.5 4.905C1.5 4.395 1.59 3.9075 1.77 3.4575C1.95 3 2.235 2.58 2.6325 2.205C3.1125 1.7325 3.6375 1.5 4.1925 1.5C4.4025 1.5 4.6125 1.545 4.8 1.635C4.995 1.725 5.1675 1.86 5.3025 2.055L7.0425 4.5075C7.1775 4.695 7.275 4.8675 7.3425 5.0325C7.41 5.19 7.4475 5.3475 7.4475 5.49C7.4475 5.67 7.395 5.85 7.29 6.0225C7.1925 6.195 7.05 6.375 6.87 6.555L6.3 7.1475C6.2175 7.23 6.18 7.3275 6.18 7.4475C6.18 7.5075 6.1875 7.56 6.2025 7.62C6.225 7.68 6.2475 7.725 6.2625 7.77C6.3975 8.0175 6.63 8.34 6.96 8.73C7.2975 9.12 7.6575 9.5175 8.0475 9.915C8.4525 10.3125 8.8425 10.68 9.24 11.0175C9.63 11.3475 9.9525 11.5725 10.2075 11.7075C10.245 11.7225 10.29 11.745 10.3425 11.7675C10.4025 11.79 10.4625 11.7975 10.53 11.7975C10.6575 11.7975 10.755 11.7525 10.8375 11.67L11.4075 11.1075C11.595 10.92 11.775 10.7775 11.9475 10.6875C12.12 10.5825 12.2925 10.53 12.48 10.53C12.6225 10.53 12.7725 10.56 12.9375 10.6275C13.1025 10.695 13.275 10.7925 13.4625 10.92L15.945 12.6825C16.14 12.8175 16.275 12.975 16.3575 13.1625C16.4325 13.35 16.4775 13.5375 16.4775 13.7475Z"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1663_1114">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <p className="order ">Request A Call</p>
            </div>
          </a>
        </div>

        {/* Property Brief */}
        <section className="brief-section sectiontopgap">
          {isModalOpen && <EMICalculator closeEmiModal={closeEmiModal} />}

          <div className="container">
            <div className="row">
              {/* {prefix === 'pid' && ( */}
              <div
                className="col-md-4"
                //  data-aos="zoom-in"
              >
                <h1 className="property_name">
                  {list?.property_details?.title}
                </h1>
                <h5 className="property_company">
                  {!["rent", "living"].includes(
                    list?.property_details?.property_service
                  )
                    ? "By"
                    : ""}{" "}
                  <span>{list?.property_details?.sub_title}</span>
                </h5>
                <p className="propert_address">
                  {list?.property_details?.location}
                </p>
              </div>
              {/* )} */}

              {/* prefix === 'rid' &&(
                            <div className='col-md-4' data-aos="fade-right">
                            <h1 className='property_name'>{list?.property_title} {list?.property_details?.location}</h1>
                            {/* <h5 className='property_company'>By <span>{list?.property_details?.sub_title}</span></h5> */}
              {/* <p className='propert_address'>{list?.property_details?.title},{list?.property_details?.location}</p>
                        </div>
                        */}
              <div className="col-md-4"></div>
              <div
                className="col-md-4"
                //  data-aos="zoom-in"
              >
                <h1 className="property_price">
                  {showPrice(list?.property_price)}
                  {list?.redirection == "pid" ? (
                    <span>
                      {avgPrice(
                        list?.property_price,
                        list?.property_details?.area
                      )}{" "}
                    </span>
                  ) : (
                    ""
                  )}
                </h1>
                {!["rent", "living"].includes(
                  list?.property_details?.property_service
                ) ? (
                  <>
                    <h5 className="property_emi" onClick={openEmiModal}>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1635_869)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12.4688 0V14H1.53125V0H12.4688ZM5.03125 10.5H3.71875V11.8125H5.03125V10.5ZM7.65625 10.5H6.34375V11.8125H7.65625V10.5ZM10.2812 10.5H8.96875V11.8125H10.2812V10.5ZM5.03125 7.875H3.71875V9.1875H5.03125V7.875ZM7.65625 7.875H6.34375V9.1875H7.65625V7.875ZM10.2812 7.875H8.96875V9.1875H10.2812V7.875ZM5.03125 5.25H3.71875V6.5625H5.03125V5.25ZM7.65625 5.25H6.34375V6.5625H7.65625V5.25ZM10.2812 5.25H8.96875V6.5625H10.2812V5.25ZM11.1562 1.3125H2.84375V3.9375H11.1562V1.3125Z"
                            fill="#EB622E"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1635_869">
                            <rect width="14" height="14" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>

                      <span>
                        EMI starts at ₹
                        {calculateEMI(list?.property_price?.[0], 30, 6.95)}
                      </span>
                    </h5>
                  </>
                ) : (
                  <h5 className="property_emi">
                    {list?.property_details?.added_on}
                  </h5>
                )}
                <p className="property_price_desc">
                  Price excludes maintenance, floor rise cost, stamp duty,
                  registration, GST etc.
                </p>
              </div>
            </div>
          </div>
        </section>

        {list?.images?.length > 0 ? (
          <div id="customCarousel" className="carousel slide">
            <div className="carousel-indicators custom-indicators">
              {list?.images &&
                chunkArray(list?.images, 3).map((_, index) => (
                  <button
                    type="button"
                    data-bs-target="#customCarousel"
                    data-bs-slide-to={index}
                    className={`indicator-button ${
                      index === 0 ? "active" : ""
                    }`}
                    aria-current={index === 0 ? "true" : "false"}
                    aria-label={`Slide ${index + 1}`}
                    key={`indicator-${index}`}
                  ></button>
                ))}
            </div>

            <div className="carousel-inner">
              {isImageModalOpen && (
                <ImageModal
                  project={list}
                  handleImagesModalClose={handleImagesModalClose}
                  contactedId={contactedId}
                  handleShowModal={handleShowModal}
                  user={user}
                  handleDispatch={handleDispatch}
                  properties={properties}
                />
              )}

              {list?.images?.length > 0 && (
                <Slider {...settings2}>
                  {list.images.map((image, index) => (
                    <div
                      key={index}
                      onClick={() => openImageModal(image?.image)}
                      style={{ padding: "0 10px" }}
                    >
                      <div className="propdtl-mask-container">
                        <img
                          src={image?.image}
                          alt={`Slide ${index + 1}`}
                          className="target-image"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = dummyImg;
                          }}
                        />
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "rgba(0,0,0,0.4)",
                            opacity: 0,
                            transition: "opacity 0.3s ease",
                          }}
                          className="image-overlay"
                        >
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                            }}
                          >
                            <img src={zoom} alt="Zoom Icon" width="30" />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              )}
            </div>

            <button
              className="carousel-control-prev custom-carousel-control-prev"
              type="button"
              data-bs-target="#customCarousel"
              data-bs-slide="prev"
            >
              <span
                className="carousel-control-prev-icon custom-carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next custom-carousel-control-next"
              type="button"
              data-bs-target="#customCarousel"
              data-bs-slide="next"
            >
              <span
                className="carousel-control-next-icon custom-carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        ) : (
          <>
            <div
              className="container"
              style={{ height: "400px", background: "rgba(27, 78, 155, 0.11)" }}
            >
              <div
                style={{ margin: "auto", width: "180px", paddingTop: "10%" }}
              >
                <img src={no_image} className="w-100" />
                <p style={{ textAlign: "center", marginTop: "10px" }}>
                  No Image is Available
                </p>
              </div>
            </div>
          </>
        )}

        <div className="mob-hide">
          <div className=" property_detail_description text-center">
            {Array.isArray(list?.property_details?.project_specifications) &&
            list.property_details?.project_specifications.length > 0
              ? list.property_details?.project_specifications
                  .filter((item) => item.value !== null && item.value !== "") // Exclude null or empty values
                  .slice(0, 5)
                  .map((item, index) => (
                    <div
                      className="property_detail_description1"
                      key={index}
                      // data-aos="fade-right"
                    >
                      <div>
                        <img
                          src={getImagePath(item.label, "svg")}
                          alt={item.label}
                        />
                      </div>
                      <p className="property_detail_value mb-0 mt-2">
                        {item.value
                          .replace(/_/g, " ")
                          .replace(/\b\w/g, (c) => c.toUpperCase())}
                      </p>
                      <p className="property_detail_label mb-0">
                        {item.label
                          .replace(/_/g, " ")
                          .replace(/\b\w/g, (c) => c.toUpperCase())}
                      </p>
                    </div>
                  ))
              : ""}
          </div>
        </div>

        <div className="property_mob_detail_box desk-hide">
          {Array.isArray(list?.property_details?.project_specifications) &&
            list.property_details?.project_specifications
              .filter((item) => item.value !== null && item.value !== "")
              .slice(0, toggle.box1 ? undefined : 2) // Show all if box1 is true, else only 2
              .map((item, index) => (
                <div className="property_mob_detail" key={index}>
                  <img
                    src={getImagePath(item.label, "svg")}
                    alt={item.label}
                    style={{ width: "20px" }}
                  />
                  <p className="property_detail_value">
                    {item.label
                      .replace(/_/g, " ")
                      .replace(/\b\w/g, (c) => c.toUpperCase())}
                    :{" "}
                    <span>
                      {item.value
                        .replace(/_/g, " ")
                        .replace(/\b\w/g, (c) => c.toUpperCase())}
                    </span>
                  </p>
                </div>
              ))}

          {Array.isArray(list?.property_details?.project_specifications) &&
            list.property_details.project_specifications.filter(
              (item) => item.value !== null && item.value !== ""
            ).length > 2 && (
              <div
                className="showmore mob"
                onClick={() => handleToggle("box1")}
              >
                {toggle.box1 ? "less..." : "more..."}
              </div>
            )}
        </div>

        <div className="row mt-3 w-100">
          <div className="col-md-3 property_detail_sidebar propdtlbxx">
            <div className="property-filter mob-hide">
              <div className="accordion mt-0" id="accordionExample">
                {list?.overview?.specifications.length > 0 && (
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <p
                        className={`accordian-btn ${
                          selectedSection == "overview-section" ? "active" : ""
                        }`}
                        onClick={(e) => ScrollToSection(e, "overview-section")}
                      >
                        Overview
                      </p>
                    </h2>
                  </div>
                )}
                {list.highlights?.length > 0 && (
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <p
                        className={`accordian-btn ${
                          selectedSection == "highlights-section"
                            ? "active"
                            : ""
                        }`}
                        onClick={(e) =>
                          ScrollToSection(e, "highlights-section")
                        }
                      >
                        Highlights
                      </p>
                    </h2>
                  </div>
                )}
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <p
                      className={`accordian-btn ${
                        selectedSection == "locality-section" ? "active" : ""
                      }`}
                      onClick={(e) => ScrollToSection(e, "locality-section")}
                    >
                      Know your locality
                    </p>
                  </h2>
                </div>
                {list?.plans?.length > 0 && (
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <p
                        className={`accordian-btn ${
                          selectedSection == "floor-section" ? "active" : ""
                        }`}
                        onClick={(e) => ScrollToSection(e, "floor-section")}
                      >
                        Floor Plan
                      </p>
                    </h2>
                  </div>
                )}
                {list.property_details?.video_link && (
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <p
                        className={`accordian-btn ${
                          selectedSection == "tour-section" ? "active" : ""
                        }`}
                        onClick={(e) => ScrollToSection(e, "tour-section")}
                      >
                        Tour This Project
                      </p>
                    </h2>
                  </div>
                )}

                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <p
                      className={`accordian-btn ${
                        selectedSection == "amenities-section" ? "active" : ""
                      }`}
                      onClick={(e) => ScrollToSection(e, "amenities-section")}
                    >
                      Amenities
                    </p>
                  </h2>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <p
                      className={`accordian-btn ${
                        selectedSection == "project-section" ? "active" : ""
                      }`}
                      onClick={(e) => ScrollToSection(e, "project-section")}
                    >
                      Project Specifications
                    </p>
                  </h2>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <p
                      className={`accordian-btn ${
                        selectedSection == "price-section" ? "active" : ""
                      }`}
                      onClick={(e) => ScrollToSection(e, "price-section")}
                    >
                      Price Trends
                    </p>
                  </h2>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <p
                      className={`accordian-btn ${
                        selectedSection == "calculator-section" ? "active" : ""
                      }`}
                      onClick={(e) => ScrollToSection(e, "calculator-section")}
                    >
                      Calculator
                    </p>
                  </h2>
                </div>
                {list?.brochure && (
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <p
                        className={`accordian-btn ${
                          selectedSection == "brochure-section" ? "active" : ""
                        }`}
                        onClick={(e) => ScrollToSection(e, "brochure-section")}
                      >
                        Brochure
                      </p>
                    </h2>
                  </div>
                )}
                {/* <div className="accordion-item">
                  <h2 className="accordion-header">
                    <p
                      className={`accordian-btn ${
                        selectedSection == "reviews-section" ? "active" : ""
                      }`}
                      onClick={(e) => ScrollToSection(e, "reviews-section")}
                    >
                      Ratings and Reviews
                    </p>
                  </h2>
                </div> */}
                {/* <div className="accordion-item">
                <h2 className="accordion-header">
                  <p
                    className={`accordian-btn ${
                      selectedSection == "compare-section" ? "active" : ""
                    }`}
                    onClick={(e) => ScrollToSection(e, "compare-section")}
                  >
                    Compare Properties
                  </p>
                </h2>
              </div> */}
                {list?.about_developer && list?.redirection == "pid" && (
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <p
                        className={`accordian-btn ${
                          selectedSection == "about-section" ? "active" : ""
                        }`}
                        onClick={(e) => ScrollToSection(e, "about-section")}
                      >
                        About Developer
                      </p>
                    </h2>
                  </div>
                )}
                {/* <div className="accordion-item">
                <h2 className="accordion-header">
                  <p
                    className={`accordian-btn ${selectedSection == "similar-section" ? "active" : ""
                      }`}
                    onClick={(e) => ScrollToSection(e, "similar-section")}
                  >
                    Similar Properties
                  </p>
                </h2>
              </div> */}
                {list?.faq_section && (
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <p
                        className={`accordian-btn ${
                          selectedSection == "faq-section" ? "active" : ""
                        }`}
                        onClick={(e) => ScrollToSection(e, "faq-section")}
                      >
                        FAQs
                      </p>
                    </h2>
                  </div>
                )}
                {list?.disclaimer && (
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <p
                        className={`accordian-btn ${
                          selectedSection == "disclaimer-section"
                            ? "active"
                            : ""
                        }`}
                        onClick={(e) =>
                          ScrollToSection(e, "disclaimer-section")
                        }
                      >
                        Disclaimer
                      </p>
                    </h2>
                  </div>
                )}
              </div>
            </div>

            <div className="dropdown explore-box desk-hide">
              <button
                className="btn btn-secondary dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Explore
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton1"
              >
                {list?.overview?.specifications.length > 0 && (
                  <li>
                    <a
                      className={`dropdown-item ${
                        selectedSection === "overview-section" ? "active" : ""
                      }`}
                      href="#"
                      onClick={(e) => ScrollToSection(e, "overview-section")}
                    >
                      Overview
                    </a>
                  </li>
                )}

                {list.highlights?.length > 0 && (
                  <li>
                    <a
                      className={`dropdown-item ${
                        selectedSection === "highlights-section" ? "active" : ""
                      }`}
                      href="#"
                      onClick={(e) => ScrollToSection(e, "highlights-section")}
                    >
                      Highlights
                    </a>
                  </li>
                )}

                <li>
                  <a
                    className={`dropdown-item ${
                      selectedSection === "locality-section" ? "active" : ""
                    }`}
                    href="#"
                    onClick={(e) => ScrollToSection(e, "locality-section")}
                  >
                    Know your locality
                  </a>
                </li>

                {list?.plans?.length > 0 && (
                  <li>
                    <a
                      className={`dropdown-item ${
                        selectedSection === "floor-section" ? "active" : ""
                      }`}
                      href="#"
                      onClick={(e) => ScrollToSection(e, "floor-section")}
                    >
                      Floor Plan
                    </a>
                  </li>
                )}

                {list.property_details?.video_link && (
                  <li>
                    <a
                      className={`dropdown-item ${
                        selectedSection === "tour-section" ? "active" : ""
                      }`}
                      href="#"
                      onClick={(e) => ScrollToSection(e, "tour-section")}
                    >
                      Tour This Project
                    </a>
                  </li>
                )}

                <li>
                  <a
                    className={`dropdown-item ${
                      selectedSection === "amenities-section" ? "active" : ""
                    }`}
                    href="#"
                    onClick={(e) => ScrollToSection(e, "amenities-section")}
                  >
                    Amenities
                  </a>
                </li>

                <li>
                  <a
                    className={`dropdown-item ${
                      selectedSection === "project-section" ? "active" : ""
                    }`}
                    href="#"
                    onClick={(e) => ScrollToSection(e, "project-section")}
                  >
                    Project Specifications
                  </a>
                </li>

                <li>
                  <a
                    className={`dropdown-item ${
                      selectedSection === "price-section" ? "active" : ""
                    }`}
                    href="#"
                    onClick={(e) => ScrollToSection(e, "price-section")}
                  >
                    Price Trends
                  </a>
                </li>

                <li>
                  <a
                    className={`dropdown-item ${
                      selectedSection === "calculator-section" ? "active" : ""
                    }`}
                    href="#"
                    onClick={(e) => ScrollToSection(e, "calculator-section")}
                  >
                    Calculator
                  </a>
                </li>

                {list?.brochure && (
                  <li>
                    <a
                      className={`dropdown-item ${
                        selectedSection === "brochure-section" ? "active" : ""
                      }`}
                      href="#"
                      onClick={(e) => ScrollToSection(e, "brochure-section")}
                    >
                      Brochure
                    </a>
                  </li>
                )}

                {/* <li>
                  <a
                    className={`dropdown-item ${
                      selectedSection === "reviews-section" ? "active" : ""
                    }`}
                    href="#"
                    onClick={(e) => ScrollToSection(e, "reviews-section")}
                  >
                    Ratings and Reviews
                  </a>
                </li> */}

                {/* Optional Compare Section */}
                {/* <li>
      <a
        className={`dropdown-item ${selectedSection === "compare-section" ? "active" : ""}`}
        href="#"
        onClick={(e) => ScrollToSection(e, "compare-section")}
      >
        Compare Properties
      </a>
    </li> */}

                {list?.about_developer && list?.redirection === "pid" && (
                  <li>
                    <a
                      className={`dropdown-item ${
                        selectedSection === "about-section" ? "active" : ""
                      }`}
                      href="#"
                      onClick={(e) => ScrollToSection(e, "about-section")}
                    >
                      About Developer
                    </a>
                  </li>
                )}

                {/* <li>
                <a
                  className={`dropdown-item ${selectedSection === "similar-section" ? "active" : ""}`}
                  href="#"
                  onClick={(e) => ScrollToSection(e, "similar-section")}
                >
                  Similar Properties
                </a>
              </li> */}

                {list?.faq_section && (
                  <li>
                    <a
                      className={`dropdown-item ${
                        selectedSection === "faq-section" ? "active" : ""
                      }`}
                      href="#"
                      onClick={(e) => ScrollToSection(e, "faq-section")}
                    >
                      FAQs
                    </a>
                  </li>
                )}

                {list?.disclaimer && (
                  <li>
                    <a
                      className={`dropdown-item ${
                        selectedSection === "disclaimer-section" ? "active" : ""
                      }`}
                      href="#"
                      onClick={(e) => ScrollToSection(e, "disclaimer-section")}
                    >
                      Disclaimer
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
          <div
            className="col-md-9"
            id="scroll-container"
            ref={containerRef}
            // style={{ height: "100vh", overflowY: "auto", scrollbarWidth:'none' }}
          >
            <div className="page-detail-address  mob-hide">
              <div className="detail-address-path">
                <span>Home</span>

                <span>
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.4751 2.03996L7.7351 5.29996C8.1201 5.68496 8.1201 6.31496 7.7351 6.69996L4.4751 9.95996"
                      stroke="#343434"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>

                <span>{list?.property_details?.city}</span>

                <span>
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.4751 2.03996L7.7351 5.29996C8.1201 5.68496 8.1201 6.31496 7.7351 6.69996L4.4751 9.95996"
                      stroke="#343434"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>

                <span className="">{list?.property_details?.location}</span>

                <span>
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.4751 2.03996L7.7351 5.29996C8.1201 5.68496 8.1201 6.31496 7.7351 6.69996L4.4751 9.95996"
                      stroke="#343434"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>

                <span className="detail-last-path">
                  {list?.property_details?.title}
                </span>
              </div>
            </div>

            <div className="overview-section" id="overview-section">
              <h1 className="overview-heading desc-title">Overview</h1>
              <p className="overview-paragraph">
                {list?.overview?.description ||
                  "No Property Description Available"}
              </p>
              {list?.overview?.specifications.length > 0 && (
                <div className="row overview-detail">
                  {Array.isArray(list?.overview?.specifications) &&
                  list.overview.specifications.length > 0 ? (
                    list.overview.specifications
                      .filter(
                        (item) => item.value !== null && item.value !== ""
                      ) // Exclude null or empty values
                      .map((item, index) => (
                        <div
                          className={`col-md-3 col-6 rg ${
                            index > 1 && !toggle.box2 ? "hide-after" : ""
                          }`}
                          key={index}
                        >
                          {toggle.box1}
                          <div className="overview-icon-detail d-flex">
                            {list?.redirection == "pid" && (
                              <div className="overview-icon-img">
                                {/* <img src={project_area} className="card-img-top" alt="DreamSakha" /> */}
                                <img
                                  src={getImagePath(item.label, "gif")}
                                  className="img-fluid"
                                  alt={item.label}
                                />
                              </div>
                            )}
                            <div className="overview-icon-description">
                              <p className="overview-description-name mb-0">
                                {["security", "brokerage"].includes(
                                  item.label
                                ) ? (
                                  <i className="fa fa-rupee"></i>
                                ) : null}
                                {String(item.value)
                                  .replace(/_/g, " ")
                                  .replace(/\b\w/g, (c) => c.toUpperCase())}
                              </p>
                              <p className="overview-description-value">
                                {item.label
                                  .replace(/_/g, " ")
                                  .replace(/\b\w/g, (c) => c.toUpperCase())}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))
                  ) : (
                    <div>No Property Specifications Available</div>
                  )}
                  <div>
                    <div
                      className="showmore mob"
                      onClick={() => handleToggle("box2")}
                    >
                      {" "}
                      {toggle.box2 ? "less..." : "more..."}
                    </div>
                  </div>
                </div>
              )}
            </div>

            {list.highlights?.length > 0 && (
              <div className="heigth-section mt-4" id="highlights-section">
                <h1 className="heigth-heading desc-title">
                  Why {list?.property_details?.title} ?
                </h1>
                <div className="height-detail mt-3">
                  <ul>
                    {list?.highlights && Object.keys(list.highlights).length > 0
                      ? Object.entries(list.highlights)
                          .filter(
                            ([_, value]) => value !== null && value !== ""
                          ) // Exclude null or empty values
                          .map(([key, value], index) => (
                            <li
                              className={
                                index > 2 && !toggle.box3 ? "hide-after" : ""
                              }
                            >
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_1663_1061)">
                                  <path
                                    d="M8.24095 15.33C12.2235 15.33 15.4819 12.1057 15.4819 8.165C15.4819 4.22425 12.2235 1 8.24095 1C4.25843 1 1 4.22425 1 8.165C1 12.1057 4.25843 15.33 8.24095 15.33Z"
                                    stroke="#343434"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M5.14746 8.26199L7.26467 10.357L11.5066 6.16699"
                                    stroke="#343434"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1663_1061">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>

                              <span>{value}</span>
                            </li>
                          ))
                      : ""}
                  </ul>
                  <div
                    className="showmore mob"
                    onClick={() => handleToggle("box3")}
                  >
                    {" "}
                    {toggle.box3 ? "less..." : "more..."}
                  </div>
                </div>
              </div>
            )}
            <div className="locality-section mt-4" id="locality-section">
              <h1 className="locality-heading desc-title">
                Know your locality
              </h1>

              <div className="property-location d-flex gap-4 mt-4">
                <div className="property-location-icon">
                  <svg
                    width="60"
                    height="60"
                    viewBox="0 0 60 60"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1663_1154)">
                      <path
                        d="M4.77204 51.9956L29.7152 59.955C29.807 59.985 29.9045 60 30.0002 60C30.0995 60 30.1989 59.9831 30.2945 59.9531L55.2545 51.69C56.4283 51.3 57.1877 50.2556 57.1877 49.0219C57.1877 47.7881 56.4302 46.7381 55.2564 46.35L40.757 41.55C40.262 41.3812 39.7352 41.655 39.572 42.1444C39.4089 42.6375 39.6752 43.1662 40.1664 43.3294L54.6658 48.1294C55.2658 48.3281 55.3127 48.8625 55.3127 49.0219C55.3127 49.1794 55.2658 49.7119 54.6677 49.9106L29.9945 58.0781L5.34392 50.2087C4.74204 50.0175 4.68954 49.485 4.68767 49.3256C4.68579 49.1681 4.72704 48.6356 5.32329 48.4294L20.3758 43.2675C20.8652 43.1006 21.1258 42.5662 20.9589 42.0769C20.7902 41.5856 20.2558 41.325 19.7683 41.4937L4.71579 46.6556C3.54767 47.0569 2.79954 48.1106 2.81267 49.3444C2.82579 50.5781 3.59454 51.6187 4.77204 51.9956Z"
                        fill="#002842"
                      />
                      <path
                        d="M32.2105 0.118282C21.2061 -1.11547 11.8442 7.46641 11.8442 18.197C11.8442 22.397 13.2111 26.1283 16.2599 30.2758L28.0911 47.3777C28.558 48.0508 29.3249 48.4539 30.1461 48.4539C30.973 48.4539 31.7455 48.0452 32.2049 47.372L40.0292 36.1352L44.4242 29.4452C47.5274 25.5189 48.8511 20.5989 48.1517 15.5927C47.0267 7.54141 40.3217 1.03328 32.2105 0.118282ZM42.9036 28.3502L38.4749 35.0852L30.6599 46.3089C30.493 46.5527 30.2436 46.5808 30.1461 46.5808C30.0486 46.5808 29.7992 46.5545 29.6324 46.3127L17.7861 29.1883C14.9736 25.3614 13.7192 21.9695 13.7192 18.197C13.7192 9.19703 21.0636 1.87516 30.0899 1.87516C30.718 1.87516 31.3555 1.91078 31.9986 1.98391C39.2736 2.80328 45.2849 8.63641 46.2936 15.8533C46.9217 20.3477 45.7349 24.7614 42.9036 28.3502Z"
                        fill="#002842"
                      />
                      <circle
                        cx="30"
                        cy="18"
                        r="12"
                        stroke="#002842"
                        stroke-width="2"
                      />
                      <path
                        d="M24.3471 24.6807V18.514H22.2915L29.9999 11.3193L37.7083 18.5138H35.6528V24.6806H31.5416V20.0556H28.4583V24.6806L24.3471 24.6807Z"
                        fill="#EB622E"
                        stroke="#EB622E"
                        stroke-miterlimit="5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1663_1154">
                        <rect width="60" height="60" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className="property-location-addrress">
                  <p className="property-location-addrress1 mb-2">
                    Property Location:{" "}
                  </p>
                  <p className="property-location-addrress2 pt-2">
                    {list?.property_details?.location},
                    {list?.property_details?.city}
                  </p>
                </div>
              </div>

              {(() => {
                const validLocalities = list?.know_your_locality
                  ? Object.entries(list.know_your_locality).filter(
                      ([_, value]) =>
                        value &&
                        value.category &&
                        value.title &&
                        value.distance_km !== null &&
                        value.distance_km !== ""
                    )
                  : [];

                return validLocalities.length > 0 ? (
                  <div className="around-locality mt-4">
                    <p className="around-locality-p">Around This Project: </p>
                    <div
                      className="around-locality-details d-flex"
                      style={{ flexWrap: "wrap", rowGap: "15px" }}
                    >
                      {validLocalities.map(([key, value], index) => (
                        <div
                          key={key}
                          className={`around-locality-description ${
                            index > 1 && !toggle.box4 ? "hide-after" : ""
                          }`}
                        >
                          <img
                            src={getImagePath(value.category, "gif")}
                            className="card-img-top"
                            alt={value.category}
                          />
                          <p className="around-locality-category mb-1">
                            {value.category}
                          </p>
                          <p className="around-locality-name mb-0 pt-2">
                            {value.title?.split(" ").slice(0, 2).join(" ")}
                            {value.title?.split(" ").length > 2 ? "..." : ""}
                          </p>
                          <p className="around-locality-distance mb-0 mt-1">
                            ({value.distance_km})
                          </p>
                        </div>
                      ))}
                    </div>

                    <div
                      className="showmore mob"
                      onClick={() => handleToggle("box4")}
                    >
                      {toggle.box4 ? "less..." : "more..."}
                    </div>
                  </div>
                ) : null;
              })()}
            </div>
            {list?.plans?.length > 0 && (
              <div className="floor-plan-section mt-4" id="floor-section">
                <div className="fptitlebox d-flex justify-content-between align-items-center">
                  <div className="floor-plane-heading desc-title">
                    <h1>Price & Floor Plan</h1>
                  </div>
                  <div className="floor-plane-buttons d-flex gap-2">
                    {list?.plans?.length > 0 ? (
                      list.plans.map((item, index) => (
                        <button
                          key={index}
                          className={`btn bhk-button ${
                            activeButton ===
                            item.label.toLowerCase().replace(/\s/g, "")
                              ? "active"
                              : ""
                          }`}
                          onClick={() =>
                            handleButtonClick(
                              item.label.toLowerCase().replace(/\s/g, "")
                            )
                          }
                        >
                          {item.label}
                        </button>
                      ))
                    ) : (
                      <p>No floor plans available</p>
                    )}
                  </div>
                </div>
                {/* Dynamic Floor Plan Details */}
                {activeData && (
                  <p className="floor-plan-detail">
                    {activeData.label} | {activeData.plan.size} sq.ft - ₹{" "}
                    {activeData.plan?.price}
                  </p>
                )}

                {/* Floor Plan Images */}
                <div className="gap-5">
                  <PlanCarosuel images={activeData?.images} />
                </div>
              </div>
            )}

            {list.property_details?.video_link && (
              <section
                className="virtual-tour-section sectiontopgap"
                id="tour-section"
              >
                <h1 className="virtual-tour-heading desc-title">
                  Virtual Tour Of the project{" "}
                </h1>
                <div className="row vtbase">
                  <div className="col-md-6 vtimgbox">
                    <div className="yt-btn">
                      <svg
                        onClick={() =>
                          playVideo(list.property_details?.video_link)
                        }
                        width="100"
                        height="100"
                        viewBox="0 0 100 100"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1690_135)">
                          <rect
                            x="36"
                            y="32"
                            width="33"
                            height="35"
                            fill="white"
                          />
                          <path
                            d="M39.6762 62.9464L66.6851 48.9955L39.6762 34.8772V62.9464ZM49.9999 14.8438C56.2499 14.8438 62.2859 14.9275 68.1081 15.0949C73.9303 15.2623 78.1993 15.439 80.915 15.625L84.9887 15.8482C85.0259 15.8482 85.3421 15.8761 85.9374 15.9319C86.5326 15.9877 86.9604 16.0435 87.2208 16.0993C87.4813 16.1551 87.9184 16.2388 88.5322 16.3504C89.1461 16.4621 89.6762 16.6109 90.1226 16.7969C90.5691 16.9829 91.0899 17.2247 91.6851 17.5223C92.2804 17.8199 92.857 18.1827 93.415 18.6105C93.9731 19.0383 94.5125 19.5312 95.0333 20.0893C95.2566 20.3125 95.5449 20.6566 95.8983 21.1217C96.2517 21.5867 96.7912 22.6749 97.5166 24.3862C98.2421 26.0975 98.735 27.9762 98.9954 30.0223C99.293 32.4033 99.5255 34.9423 99.6929 37.6395C99.8604 40.3367 99.9627 42.4479 99.9999 43.9732V53.7946C100.037 59.189 99.7022 64.5833 98.9954 69.9777C98.735 72.0238 98.27 73.8746 97.6003 75.5301C96.9307 77.1856 96.3354 78.3296 95.8146 78.9621L95.0333 79.9107C94.5125 80.4688 93.9731 80.9617 93.415 81.3895C92.857 81.8173 92.2804 82.1708 91.6851 82.4498C91.0899 82.7288 90.5691 82.9613 90.1226 83.1473C89.6762 83.3333 89.1461 83.4821 88.5322 83.5938C87.9184 83.7054 87.472 83.7891 87.1929 83.8449C86.9139 83.9007 86.4861 83.9565 85.9095 84.0123C85.3328 84.0681 85.0259 84.096 84.9887 84.096C75.6509 84.8028 63.988 85.1562 49.9999 85.1562C42.299 85.0818 35.6118 84.9609 29.9385 84.7935C24.2651 84.6261 20.5356 84.4866 18.7499 84.375L16.0155 84.1518L14.0066 83.9286C12.6673 83.7426 11.6535 83.5565 10.9653 83.3705C10.277 83.1845 9.32836 82.7939 8.11928 82.1987C6.9102 81.6034 5.85924 80.8408 4.96638 79.9107C4.74316 79.6875 4.45485 79.3434 4.10142 78.8783C3.748 78.4133 3.20857 77.3251 2.48312 75.6138C1.75767 73.9025 1.26474 72.0238 1.00432 69.9777C0.706706 67.5967 0.474191 65.0577 0.30678 62.3605C0.139369 59.6633 0.0370629 57.5521 -0.000139505 56.0268V46.2054C-0.0373419 40.811 0.29748 35.4167 1.00432 30.0223C1.26474 27.9762 1.72977 26.1254 2.39941 24.4699C3.06906 22.8144 3.66429 21.6704 4.18513 21.0379L4.96638 20.0893C5.48721 19.5312 6.02665 19.0383 6.58468 18.6105C7.14272 18.1827 7.71935 17.8199 8.31459 17.5223C8.90983 17.2247 9.43066 16.9829 9.87709 16.7969C10.3235 16.6109 10.8537 16.4621 11.4675 16.3504C12.0813 16.2388 12.5185 16.1551 12.7789 16.0993C13.0393 16.0435 13.4671 15.9877 14.0624 15.9319C14.6576 15.8761 14.9738 15.8482 15.011 15.8482C24.3488 15.1786 36.0118 14.8438 49.9999 14.8438Z"
                            fill="#FF0000"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1690_135">
                            <rect width="100" height="100" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <img
                      src={mask}
                      className="virtual-tour-img"
                      alt="DreamSakha"
                    />
                  </div>
                  <div className="col-md-6">
                    <div className="virtual-tour-details">
                      <h1>Unlock Your Dream Home</h1>
                      <div>
                        {Array.isArray(
                          list?.property_details?.project_specifications
                        ) &&
                        list.property_details?.project_specifications.length > 0
                          ? list.property_details?.project_specifications
                              .filter(
                                (item) =>
                                  item.value !== null && item.value !== ""
                              ) // Exclude null or empty values
                              .slice(0, 5)
                              .map((item, index) => (
                                <div className="virtual-tour-description">
                                  <p className="svg-p">
                                    <img
                                      style={{ width: "14px" }}
                                      src={getImagePath(
                                        "sm_" + item.label,
                                        "svg"
                                      )}
                                      alt={item.label}
                                    />
                                    {item.label
                                      .replace(/_/g, " ")
                                      .replace(/\b\w/g, (c) => c.toUpperCase())}
                                  </p>
                                  <p className="svg-p-value">
                                    :{" "}
                                    {item.value
                                      .replace(/_/g, " ")
                                      .replace(/\b\w/g, (c) => c.toUpperCase())}
                                  </p>
                                </div>
                              ))
                          : ""}

                        <button className="btn book-button">Book Now</button>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}

            <div className="amenities-section mt-4" id="amenities-section">
              <h1 className="amenities-heading desc-title">
                Project Amenities
              </h1>
              <div
                className="row justify-content-evenly mt-3"
                style={{ rowGap: "15px" }}
              >
                {list?.amenities && Object.keys(list.amenities).length > 0
                  ? Object.entries(list.amenities).map(
                      ([key, value], index) => (
                        <div
                          className={`col-md-2 col-2 project-amenities ${
                            index > 1 && !toggle.box5 ? "hide-after" : ""
                          }`}
                        >
                          <img
                            src={value.icon}
                            className="card-img-top"
                            alt="DreamSakha"
                          />
                          <p className="mb-0 pt-2">{value.name}</p>
                        </div>
                      )
                    )
                  : ""}
              </div>
              <div
                className="showmore mob"
                onClick={() => handleToggle("box5")}
              >
                {" "}
                {toggle.box5 ? "less..." : "more..."}
              </div>
            </div>

            <div className="specification-section mt-4" id="project-section">
              <h1 className="specification-heading desc-title">
                Project Specifications
              </h1>
              <div className="specification-details">
                <div className="floor-countert-section mt-3">
                  <div className="specification-detail-heading">
                    <img src={tile} alt="DreamSakha" />
                    <p className="mb-0 pt-2">Floor & Counter</p>
                  </div>
                  <div className="specification-detail-body-container mt-3">
                    <div className="specification-detail-body">
                      <span className="specification-body-lable">
                        Living/Dining
                      </span>
                      <svg
                        className="desk"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.5 7.5L2.5 7.5M12.5 7.5L10 10M12.5 7.5L10 5"
                          stroke="#343434"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <span className="specification-body-value">
                        Vitrified Tiles
                      </span>
                    </div>

                    <div className="specification-detail-body">
                      <span className="specification-body-lable">
                        Master Bedroom
                      </span>
                      <svg
                        className="desk"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.5 7.5L2.5 7.5M12.5 7.5L10 10M12.5 7.5L10 5"
                          stroke="#343434"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <span className="specification-body-value">
                        Vitrified Tiles
                      </span>
                    </div>
                    {toggle.box6 && (
                      <>
                        <div className="specification-detail-body">
                          <span className="specification-body-lable">
                            Other Bedroom
                          </span>
                          <svg
                            className="desk"
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.5 7.5L2.5 7.5M12.5 7.5L10 10M12.5 7.5L10 5"
                              stroke="#343434"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span className="specification-body-value">
                            Vitrified Tiles
                          </span>
                        </div>
                        <div className="specification-detail-body">
                          <span className="specification-body-lable">
                            Kitchen
                          </span>
                          <svg
                            className="desk"
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.5 7.5L2.5 7.5M12.5 7.5L10 10M12.5 7.5L10 5"
                              stroke="#343434"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span className="specification-body-value">
                            Vitrified Tiles
                          </span>
                        </div>
                        <div className="specification-detail-body">
                          <span className="specification-body-lable">
                            Toilets
                          </span>
                          <svg
                            className="desk"
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.5 7.5L2.5 7.5M12.5 7.5L10 10M12.5 7.5L10 5"
                              stroke="#343434"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span className="specification-body-value">
                            Anti Skid Tiles
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                  <div
                    className="showmore"
                    onClick={() => handleToggle("box6")}
                  >
                    {" "}
                    {toggle.box6 ? "less..." : "more..."}
                  </div>
                </div>
                <div className="fitting-section mt-3">
                  <div className="specification-detail-heading">
                    <img src={sink} alt="DreamSakha" />
                    <p className="mb-0 pt-2">Fitting</p>
                  </div>
                  <div className="specification-detail-body-container mt-3">
                    <div className="specification-detail-body">
                      <span className="specification-body-lable">
                        Living/Dining
                      </span>
                      <svg
                        className="desk"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.5 7.5L2.5 7.5M12.5 7.5L10 10M12.5 7.5L10 5"
                          stroke="#343434"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <span className="specification-body-value">
                        Vitrified Tiles
                      </span>
                    </div>
                    <div className="specification-detail-body">
                      <span className="specification-body-lable">
                        Master Bedroom
                      </span>
                      <svg
                        className="desk"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.5 7.5L2.5 7.5M12.5 7.5L10 10M12.5 7.5L10 5"
                          stroke="#343434"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <span className="specification-body-value">
                        Vitrified Tiles
                      </span>
                    </div>

                    {toggle.box7 && (
                      <>
                        <div className="specification-detail-body">
                          <span className="specification-body-lable">
                            Other Bedroom
                          </span>
                          <svg
                            className="desk"
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.5 7.5L2.5 7.5M12.5 7.5L10 10M12.5 7.5L10 5"
                              stroke="#343434"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span className="specification-body-value">
                            Vitrified Tiles
                          </span>
                        </div>
                        <div className="specification-detail-body">
                          <span className="specification-body-lable">
                            Kitchen
                          </span>
                          <svg
                            className="desk"
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.5 7.5L2.5 7.5M12.5 7.5L10 10M12.5 7.5L10 5"
                              stroke="#343434"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span className="specification-body-value">
                            Vitrified Tiles
                          </span>
                        </div>
                        <div className="specification-detail-body">
                          <span className="specification-body-lable">
                            Toilets
                          </span>
                          <svg
                            className="desk"
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.5 7.5L2.5 7.5M12.5 7.5L10 10M12.5 7.5L10 5"
                              stroke="#343434"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span className="specification-body-value">
                            Anti Skid Tiles
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                  <div
                    className="showmore"
                    onClick={() => handleToggle("box7")}
                  >
                    {" "}
                    {toggle.box7 ? "less..." : "more..."}
                  </div>
                </div>
                <div className="wall-celling-section mt-3">
                  <div className="specification-detail-heading">
                    <img src={wall} alt="DreamSakha" />
                    <p className="mb-0 pt-2">Wall & Ceiling</p>
                  </div>
                  <div className="specification-detail-body-container mt-3">
                    <div className="specification-detail-body">
                      <span className="specification-body-lable">
                        Living/Dining
                      </span>
                      <svg
                        className="desk"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.5 7.5L2.5 7.5M12.5 7.5L10 10M12.5 7.5L10 5"
                          stroke="#343434"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <span className="specification-body-value">
                        Vitrified Tiles
                      </span>
                    </div>
                    <div className="specification-detail-body">
                      <span className="specification-body-lable">
                        Master Bedroom
                      </span>
                      <svg
                        className="desk"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.5 7.5L2.5 7.5M12.5 7.5L10 10M12.5 7.5L10 5"
                          stroke="#343434"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <span className="specification-body-value">
                        Vitrified Tiles
                      </span>
                    </div>
                    {toggle.box8 && (
                      <>
                        <div className="specification-detail-body">
                          <span className="specification-body-lable">
                            Other Bedroom
                          </span>
                          <svg
                            className="desk"
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.5 7.5L2.5 7.5M12.5 7.5L10 10M12.5 7.5L10 5"
                              stroke="#343434"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span className="specification-body-value">
                            Vitrified Tiles
                          </span>
                        </div>
                        <div className="specification-detail-body">
                          <span className="specification-body-lable">
                            Kitchen
                          </span>
                          <svg
                            className="desk"
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.5 7.5L2.5 7.5M12.5 7.5L10 10M12.5 7.5L10 5"
                              stroke="#343434"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span className="specification-body-value">
                            Vitrified Tiles
                          </span>
                        </div>
                        <div className="specification-detail-body">
                          <span className="specification-body-lable">
                            Toilets
                          </span>
                          <svg
                            className="desk"
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.5 7.5L2.5 7.5M12.5 7.5L10 10M12.5 7.5L10 5"
                              stroke="#343434"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span className="specification-body-value">
                            Anti Skid Tiles
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                  <div
                    className="showmore"
                    onClick={() => handleToggle("box8")}
                  >
                    {" "}
                    {toggle.box8 ? "less..." : "more..."}
                  </div>
                </div>
              </div>
            </div>

            <div className="price-trend-section mt-4" id="price-section">
              <h1 className="price-trend-heading desc-title">
                Price Trends for Vaishali Nagar Extension
              </h1>
              <p className="price-trend-paragraph">
                (Apartments - in last 1 year)
              </p>
              <div className="pricetrndgrf">
                <Line data={data} options={options} />
              </div>
            </div>

            <div className="calculator-section mt-4" id="calculator-section">
              <h1 className="calculator-heading desc-title">Calculator</h1>

              <div className="secemicalbox">
                {isModalOpen && <EMICalculator closeEmiModal={closeEmiModal} />}
              </div>
              <div className="row mt-3">
                <div
                  className="col-md-3 col-6"
                  style={{ position: "relative", cursor: "pointer" }}
                >
                  <div
                    className="calculator-detail"
                    onClick={() => openEmiModal()}
                  >
                    <img src={emi} className="img-fluid" alt="DreamSakha" />
                    <p className="mt-3">EMI Calculator</p>
                  </div>
                </div>
                <div className="col-md-3 col-6">
                  <div className="calculator-detail">
                    <img
                      src={affordable}
                      className="img-fluid"
                      alt="DreamSakha"
                    />
                    <p className="mt-3">Affordability Calculator</p>
                  </div>
                </div>
                <div className="col-md-3 col-6">
                  <div className="calculator-detail">
                    <img
                      src={eligibility}
                      className="img-fluid"
                      alt="DreamSakha"
                    />
                    <p className="mt-3">Eligibility Calculator</p>
                  </div>
                </div>
                <div className="col-md-3 col-6">
                  <div className="calculator-detail">
                    <img
                      src={property_value}
                      className="img-fluid"
                      alt="DreamSakha"
                    />
                    <p className="mt-3">Property Value Calculator</p>
                  </div>
                </div>
              </div>
            </div>
            {list?.brochure && (
              <div
                className="brochure-section mt-4 mb-4 "
                id="brochure-section"
              >
                <div className="mob-hide" style={{ padding: "1px 0px" }}>
                  <div
                    className="brochure-header d-flex justify-content-between align-items-center"
                    style={{ marginTop: "36px" }}
                  >
                    <div
                      className="brochbx d-flex justify-content-between align-items-center"
                      style={{ width: "100%" }}
                    >
                      <h1 className="brochure-header-heading desc-title">
                        Brochure
                      </h1>
                      <div className="brochure-header-button d-flex gap-3">
                        <button
                          onClick={() => downloadBrochure(list?.brochure)}
                          className="btn brochure-button-view"
                        >
                          <img src={getImagePath("eye", "svg")} />
                          View Brochure
                        </button>
                        <button
                          className="btn brochure-button-download"
                          onClick={() => downloadBrochure(list?.brochure)}
                        >
                          <img src={getImagePath("download", "svg")} />
                          Download Brochure
                        </button>
                      </div>
                    </div>
                    {/* <div className='slider-button'>
                                    <svg onClick={goToPrevious} data-bs-target="#imageCarousel" data-bs-slide="prev" width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M21 3.49999C11.3347 3.49999 3.49999 11.3347 3.49999 21C3.49999 30.6652 11.3347 38.5 21 38.5C30.6652 38.5 38.5 30.6652 38.5 21C38.5 11.3347 30.6652 3.49999 21 3.49999Z" stroke="#002842" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M23.2051 14.8227L17.0451 21.0002L23.2051 27.1777" stroke="#002842" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <svg onClick={goToNext} data-bs-target="#imageCarousel" data-bs-slide="next" width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M21 38.5C30.6653 38.5 38.5 30.6653 38.5 21C38.5 11.3348 30.6653 3.5 21 3.5C11.3348 3.5 3.5 11.3348 3.5 21C3.5 30.6653 11.3348 38.5 21 38.5Z" stroke="#002842" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M18.7949 27.1773L24.9549 20.9998L18.7949 14.8223" stroke="#002842" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div> */}
                  </div>
                </div>

                <div className="desk-hide">
                  <div className="mob-brochure-box d-flex justify-content-between align-items-center">
                    <div className="floor-plane-heading desc-title">
                      <h1>Brochure</h1>
                    </div>
                    <div className="floor-plane-buttons d-flex gap-2 justify-content-center pt-3">
                      <button
                        className={`btn bhk-button ${
                          activeButton === "3bhk" ? "active" : ""
                        }`}
                        onClick={() => handleButtonClick("3bhk")}
                      >
                        View Brochure
                      </button>
                      <button
                        className={`btn bhk-button ${
                          activeButton === "4bhk" ? "active" : ""
                        }`}
                        onClick={() => handleButtonClick("4bhk")}
                      >
                        Download Brochure
                      </button>
                    </div>
                  </div>

                  {/* <div className='slider-button'>
                                <svg onClick={goToPrevious} data-bs-target="#imageCarousel" data-bs-slide="prev" width="30" height="30" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21 3.49999C11.3347 3.49999 3.49999 11.3347 3.49999 21C3.49999 30.6652 11.3347 38.5 21 38.5C30.6652 38.5 38.5 30.6652 38.5 21C38.5 11.3347 30.6652 3.49999 21 3.49999Z" stroke="#002842" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M23.2051 14.8227L17.0451 21.0002L23.2051 27.1777" stroke="#002842" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <svg onClick={goToNext} data-bs-target="#imageCarousel" data-bs-slide="next" width="30" height="30" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21 38.5C30.6653 38.5 38.5 30.6653 38.5 21C38.5 11.3348 30.6653 3.5 21 3.5C11.3348 3.5 3.5 11.3348 3.5 21C3.5 30.6653 11.3348 38.5 21 38.5Z" stroke="#002842" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M18.7949 27.1773L24.9549 20.9998L18.7949 14.8223" stroke="#002842" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div> */}
                </div>

                {/* <div className='mt-3'>
                            <Slider {...settings} ref={sliderRef}>
                                <div className="featureslides">
                                    <div className="fslidebox">
                                        <div className="featurebox" >
                                            <img src={detailimg2} alt="DreamSakha 1" />
                                        </div>
                                    </div>
                                </div>

                                <div className="featureslides">
                                    <div className="fslidebox">
                                        <div className="">
                                            <img src={detailimg1} alt="DreamSakha 2" />
                                        </div>
                                    </div>
                                </div>

                                <div className="featureslides">
                                    <div className="fslidebox">
                                        <div className="featurebox">
                                            <img src={detailimg2} alt="DreamSakha 3" />
                                        </div>
                                    </div>
                                </div>

                                <div className="featureslides">
                                    <div className="fslidebox">
                                        <div className="featurebox">
                                            <img src={detailimg1} alt="DreamSakha 4" />
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                        </div> */}
              </div>
            )}
            {/* <div className="review-section mt-4 mb-4" id="reviews-section">
              <div className="review-section-header">
                <h1 className="calculator-heading desc-title">
                  Ratings and Reviews
                </h1>
                <div>
                  <div className="review-start">
                    <svg
                      width="120"
                      height="24"
                      viewBox="0 0 120 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.2691 4.41115C11.5006 3.89177 11.6164 3.63208 11.7776 3.55211C11.9176 3.48263 12.082 3.48263 12.222 3.55211C12.3832 3.63208 12.499 3.89177 12.7305 4.41115L14.5745 8.54808C14.643 8.70162 14.6772 8.77839 14.7302 8.83718C14.777 8.8892 14.8343 8.93081 14.8982 8.95929C14.9705 8.99149 15.0541 9.00031 15.2213 9.01795L19.7256 9.49336C20.2911 9.55304 20.5738 9.58288 20.6997 9.71147C20.809 9.82316 20.8598 9.97956 20.837 10.1342C20.8108 10.3122 20.5996 10.5025 20.1772 10.8832L16.8125 13.9154C16.6877 14.0279 16.6252 14.0842 16.5857 14.1527C16.5507 14.2134 16.5288 14.2807 16.5215 14.3503C16.5132 14.429 16.5306 14.5112 16.5655 14.6757L17.5053 19.1064C17.6233 19.6627 17.6823 19.9408 17.5989 20.1002C17.5264 20.2388 17.3934 20.3354 17.2393 20.3615C17.0619 20.3915 16.8156 20.2495 16.323 19.9654L12.3995 17.7024C12.2539 17.6184 12.1811 17.5765 12.1037 17.56C12.0352 17.5455 11.9644 17.5455 11.8959 17.56C11.8185 17.5765 11.7457 17.6184 11.6001 17.7024L7.67662 19.9654C7.18404 20.2495 6.93775 20.3915 6.76034 20.3615C6.60623 20.3354 6.47319 20.2388 6.40075 20.1002C6.31736 19.9408 6.37635 19.6627 6.49434 19.1064L7.4341 14.6757C7.46898 14.5112 7.48642 14.429 7.47814 14.3503C7.47081 14.2807 7.44894 14.2134 7.41394 14.1527C7.37439 14.0842 7.31195 14.0279 7.18708 13.9154L3.82246 10.8832C3.40005 10.5025 3.18884 10.3122 3.16258 10.1342C3.13978 9.97956 3.19059 9.82316 3.29993 9.71147C3.42581 9.58288 3.70856 9.55304 4.27406 9.49336L8.77835 9.01795C8.94553 9.00031 9.02911 8.99149 9.10139 8.95929C9.16534 8.93081 9.2226 8.8892 9.26946 8.83718C9.32241 8.77839 9.35663 8.70162 9.42508 8.54808L11.2691 4.41115Z"
                        fill="#FFC400"
                        stroke="#FFC300"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M35.2691 4.41115C35.5006 3.89177 35.6164 3.63208 35.7776 3.55211C35.9176 3.48263 36.082 3.48263 36.222 3.55211C36.3832 3.63208 36.499 3.89177 36.7305 4.41115L38.5745 8.54808C38.643 8.70162 38.6772 8.77839 38.7302 8.83718C38.777 8.8892 38.8343 8.93081 38.8982 8.95929C38.9705 8.99149 39.0541 9.00031 39.2213 9.01795L43.7256 9.49336C44.2911 9.55304 44.5738 9.58288 44.6997 9.71147C44.809 9.82316 44.8598 9.97956 44.837 10.1342C44.8108 10.3122 44.5996 10.5025 44.1772 10.8832L40.8125 13.9154C40.6877 14.0279 40.6252 14.0842 40.5857 14.1527C40.5507 14.2134 40.5288 14.2807 40.5215 14.3503C40.5132 14.429 40.5306 14.5112 40.5655 14.6757L41.5053 19.1064C41.6233 19.6627 41.6823 19.9408 41.5989 20.1002C41.5264 20.2388 41.3934 20.3354 41.2393 20.3615C41.0619 20.3915 40.8156 20.2495 40.323 19.9654L36.3995 17.7024C36.2539 17.6184 36.1811 17.5765 36.1037 17.56C36.0352 17.5455 35.9644 17.5455 35.8959 17.56C35.8185 17.5765 35.7457 17.6184 35.6001 17.7024L31.6766 19.9654C31.184 20.2495 30.9378 20.3915 30.7603 20.3615C30.6062 20.3354 30.4732 20.2388 30.4008 20.1002C30.3174 19.9408 30.3764 19.6627 30.4943 19.1064L31.4341 14.6757C31.469 14.5112 31.4864 14.429 31.4781 14.3503C31.4708 14.2807 31.4489 14.2134 31.4139 14.1527C31.3744 14.0842 31.312 14.0279 31.1871 13.9154L27.8225 10.8832C27.4001 10.5025 27.1888 10.3122 27.1626 10.1342C27.1398 9.97956 27.1906 9.82316 27.2999 9.71147C27.4258 9.58288 27.7086 9.55304 28.2741 9.49336L32.7784 9.01795C32.9455 9.00031 33.0291 8.99149 33.1014 8.95929C33.1653 8.93081 33.2226 8.8892 33.2695 8.83718C33.3224 8.77839 33.3566 8.70162 33.4251 8.54808L35.2691 4.41115Z"
                        fill="#FFC300"
                        stroke="#FFC300"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M59.2691 4.41115C59.5006 3.89177 59.6164 3.63208 59.7776 3.55211C59.9176 3.48263 60.082 3.48263 60.222 3.55211C60.3832 3.63208 60.499 3.89177 60.7305 4.41115L62.5745 8.54808C62.643 8.70162 62.6772 8.77839 62.7302 8.83718C62.777 8.8892 62.8343 8.93081 62.8982 8.95929C62.9705 8.99149 63.0541 9.00031 63.2213 9.01795L67.7256 9.49336C68.2911 9.55304 68.5738 9.58288 68.6997 9.71147C68.809 9.82316 68.8598 9.97956 68.837 10.1342C68.8108 10.3122 68.5996 10.5025 68.1772 10.8832L64.8125 13.9154C64.6877 14.0279 64.6252 14.0842 64.5857 14.1527C64.5507 14.2134 64.5288 14.2807 64.5215 14.3503C64.5132 14.429 64.5306 14.5112 64.5655 14.6757L65.5053 19.1064C65.6233 19.6627 65.6823 19.9408 65.5989 20.1002C65.5264 20.2388 65.3934 20.3354 65.2393 20.3615C65.0619 20.3915 64.8156 20.2495 64.323 19.9654L60.3995 17.7024C60.2539 17.6184 60.1811 17.5765 60.1037 17.56C60.0352 17.5455 59.9644 17.5455 59.8959 17.56C59.8185 17.5765 59.7457 17.6184 59.6001 17.7024L55.6766 19.9654C55.184 20.2495 54.9378 20.3915 54.7603 20.3615C54.6062 20.3354 54.4732 20.2388 54.4008 20.1002C54.3174 19.9408 54.3764 19.6627 54.4943 19.1064L55.4341 14.6757C55.469 14.5112 55.4864 14.429 55.4781 14.3503C55.4708 14.2807 55.4489 14.2134 55.4139 14.1527C55.3744 14.0842 55.312 14.0279 55.1871 13.9154L51.8225 10.8832C51.4001 10.5025 51.1888 10.3122 51.1626 10.1342C51.1398 9.97956 51.1906 9.82316 51.2999 9.71147C51.4258 9.58288 51.7086 9.55304 52.2741 9.49336L56.7784 9.01795C56.9455 9.00031 57.0291 8.99149 57.1014 8.95929C57.1653 8.93081 57.2226 8.8892 57.2695 8.83718C57.3224 8.77839 57.3566 8.70162 57.4251 8.54808L59.2691 4.41115Z"
                        fill="#FFC300"
                        stroke="#FFC300"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M83.2691 4.41115C83.5006 3.89177 83.6164 3.63208 83.7776 3.55211C83.9176 3.48263 84.082 3.48263 84.222 3.55211C84.3832 3.63208 84.499 3.89177 84.7305 4.41115L86.5745 8.54808C86.643 8.70162 86.6772 8.77839 86.7302 8.83718C86.777 8.8892 86.8343 8.93081 86.8982 8.95929C86.9705 8.99149 87.0541 9.00031 87.2213 9.01795L91.7256 9.49336C92.2911 9.55304 92.5738 9.58288 92.6997 9.71147C92.809 9.82316 92.8598 9.97956 92.837 10.1342C92.8108 10.3122 92.5996 10.5025 92.1772 10.8832L88.8125 13.9154C88.6877 14.0279 88.6252 14.0842 88.5857 14.1527C88.5507 14.2134 88.5288 14.2807 88.5215 14.3503C88.5132 14.429 88.5306 14.5112 88.5655 14.6757L89.5053 19.1064C89.6233 19.6627 89.6823 19.9408 89.5989 20.1002C89.5264 20.2388 89.3934 20.3354 89.2393 20.3615C89.0619 20.3915 88.8156 20.2495 88.323 19.9654L84.3995 17.7024C84.2539 17.6184 84.1811 17.5765 84.1037 17.56C84.0352 17.5455 83.9644 17.5455 83.8959 17.56C83.8185 17.5765 83.7457 17.6184 83.6001 17.7024L79.6766 19.9654C79.184 20.2495 78.9378 20.3915 78.7603 20.3615C78.6062 20.3354 78.4732 20.2388 78.4008 20.1002C78.3174 19.9408 78.3764 19.6627 78.4943 19.1064L79.4341 14.6757C79.469 14.5112 79.4864 14.429 79.4781 14.3503C79.4708 14.2807 79.4489 14.2134 79.4139 14.1527C79.3744 14.0842 79.312 14.0279 79.1871 13.9154L75.8225 10.8832C75.4001 10.5025 75.1888 10.3122 75.1626 10.1342C75.1398 9.97956 75.1906 9.82316 75.2999 9.71147C75.4258 9.58288 75.7086 9.55304 76.2741 9.49336L80.7784 9.01795C80.9455 9.00031 81.0291 8.99149 81.1014 8.95929C81.1653 8.93081 81.2226 8.8892 81.2695 8.83718C81.3224 8.77839 81.3566 8.70162 81.4251 8.54808L83.2691 4.41115Z"
                        fill="#FFC300"
                        stroke="#FFC300"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M107.269 4.41115C107.501 3.89177 107.616 3.63208 107.778 3.55211C107.918 3.48263 108.082 3.48263 108.222 3.55211C108.383 3.63208 108.499 3.89177 108.731 4.41115L110.575 8.54808C110.643 8.70162 110.677 8.77839 110.73 8.83718C110.777 8.8892 110.834 8.93081 110.898 8.95929C110.971 8.99149 111.054 9.00031 111.221 9.01795L115.726 9.49336C116.291 9.55304 116.574 9.58288 116.7 9.71147C116.809 9.82316 116.86 9.97956 116.837 10.1342C116.811 10.3122 116.6 10.5025 116.177 10.8832L112.813 13.9154C112.688 14.0279 112.625 14.0842 112.586 14.1527C112.551 14.2134 112.529 14.2807 112.522 14.3503C112.513 14.429 112.531 14.5112 112.566 14.6757L113.505 19.1064C113.623 19.6627 113.682 19.9408 113.599 20.1002C113.526 20.2388 113.393 20.3354 113.239 20.3615C113.062 20.3915 112.816 20.2495 112.323 19.9654L108.4 17.7024C108.254 17.6184 108.181 17.5765 108.104 17.56C108.035 17.5455 107.964 17.5455 107.896 17.56C107.819 17.5765 107.746 17.6184 107.6 17.7024L103.677 19.9654C103.184 20.2495 102.938 20.3915 102.76 20.3615C102.606 20.3354 102.473 20.2388 102.401 20.1002C102.317 19.9408 102.376 19.6627 102.494 19.1064L103.434 14.6757C103.469 14.5112 103.486 14.429 103.478 14.3503C103.471 14.2807 103.449 14.2134 103.414 14.1527C103.374 14.0842 103.312 14.0279 103.187 13.9154L99.8225 10.8832C99.4001 10.5025 99.1888 10.3122 99.1626 10.1342C99.1398 9.97956 99.1906 9.82316 99.2999 9.71147C99.4258 9.58288 99.7086 9.55304 100.274 9.49336L104.778 9.01795C104.946 9.00031 105.029 8.99149 105.101 8.95929C105.165 8.93081 105.223 8.8892 105.269 8.83718C105.322 8.77839 105.357 8.70162 105.425 8.54808L107.269 4.41115Z"
                        stroke="#FFC300"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <p>4.2 out of 5</p>
                  </div>
                  <p>1,753 global ratings</p>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div
                    id="reviewCarousel"
                    className="carousel slide review-sld"
                    data-bs-ride="carousel"
                  >
                    <div className="carousel-inner">
                      <div className="carousel-item active">
                        <div className="card1">
                          <div className="card-header">
                            <div className="d-flex align-items-center gap-3">
                              <img
                                src={seller}
                                className="review-crousel-img"
                                alt="DreamSakha"
                              />
                              <div className="d-flex justify-content-between w-100 lh-1">
                                <div>
                                  <p className="client-name">Lakshman Singh</p>
                                  <svg
                                    width="114"
                                    height="18"
                                    viewBox="0 0 114 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.45207 3.30836C8.6257 2.91883 8.71254 2.72406 8.83345 2.66408C8.93845 2.61197 9.06175 2.61197 9.16675 2.66408C9.28764 2.72406 9.3745 2.91883 9.54812 3.30836L10.9311 6.41106C10.9825 6.52622 11.0081 6.58379 11.0479 6.62789C11.083 6.6669 11.126 6.69811 11.1739 6.71947C11.2281 6.74362 11.2908 6.75023 11.4162 6.76346L14.7944 7.12002C15.2186 7.16478 15.4306 7.18716 15.525 7.2836C15.607 7.36737 15.6451 7.48467 15.628 7.60065C15.6083 7.73415 15.4499 7.87688 15.1331 8.1624L12.6096 10.4366C12.516 10.5209 12.4691 10.5632 12.4395 10.6145C12.4133 10.6601 12.3968 10.7105 12.3914 10.7627C12.3851 10.8218 12.3982 10.8834 12.4244 11.0068L13.1292 14.3298C13.2177 14.747 13.262 14.9556 13.1994 15.0752C13.145 15.1791 13.0453 15.2516 12.9297 15.2711C12.7967 15.2936 12.6119 15.1871 12.2425 14.9741L9.29987 13.2768C9.19067 13.2138 9.13607 13.1824 9.07802 13.17C9.02664 13.1591 8.97354 13.1591 8.92217 13.17C8.86412 13.1824 8.80952 13.2138 8.70032 13.2768L5.75771 14.9741C5.38827 15.1871 5.20356 15.2936 5.0705 15.2711C4.95492 15.2516 4.85514 15.1791 4.80081 15.0752C4.73826 14.9556 4.78251 14.747 4.871 14.3298L5.57582 11.0068C5.60198 10.8834 5.61506 10.8218 5.60885 10.7627C5.60335 10.7105 5.58695 10.6601 5.5607 10.6145C5.53104 10.5632 5.48421 10.5209 5.39055 10.4366L2.86709 8.1624C2.55028 7.87688 2.39187 7.73415 2.37218 7.60065C2.35508 7.48467 2.39319 7.36737 2.47519 7.2836C2.5696 7.18716 2.78166 7.16478 3.20579 7.12002L6.58401 6.76346C6.70939 6.75023 6.77208 6.74362 6.82629 6.71947C6.87425 6.69811 6.91719 6.6669 6.95234 6.62789C6.99205 6.58379 7.01772 6.52622 7.06905 6.41106L8.45207 3.30836Z"
                                      fill="#FFC400"
                                      stroke="#FFC300"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M32.4521 3.30836C32.6257 2.91883 32.7125 2.72406 32.8334 2.66408C32.9384 2.61197 33.0617 2.61197 33.1667 2.66408C33.2876 2.72406 33.3745 2.91883 33.5481 3.30836L34.9311 6.41106C34.9825 6.52622 35.0081 6.58379 35.0479 6.62788C35.083 6.6669 35.126 6.69811 35.1739 6.71947C35.2281 6.74362 35.2908 6.75023 35.4162 6.76346L38.7944 7.12002C39.2186 7.16478 39.4306 7.18716 39.525 7.2836C39.607 7.36737 39.6451 7.48467 39.628 7.60065C39.6083 7.73415 39.4499 7.87687 39.1331 8.1624L36.6096 10.4365C36.516 10.5209 36.4691 10.5632 36.4395 10.6145C36.4133 10.6601 36.3968 10.7105 36.3914 10.7627C36.3851 10.8217 36.3982 10.8834 36.4244 11.0068L37.1292 14.3298C37.2177 14.747 37.262 14.9556 37.1994 15.0752C37.145 15.1791 37.0453 15.2515 36.9297 15.2711C36.7967 15.2936 36.6119 15.1871 36.2425 14.9741L33.2999 13.2768C33.1907 13.2138 33.1361 13.1824 33.078 13.17C33.0266 13.1591 32.9735 13.1591 32.9222 13.17C32.8641 13.1824 32.8095 13.2138 32.7003 13.2768L29.7577 14.9741C29.3883 15.1871 29.2036 15.2936 29.0705 15.2711C28.9549 15.2515 28.8551 15.1791 28.8008 15.0752C28.7383 14.9556 28.7825 14.747 28.871 14.3298L29.5758 11.0068C29.602 10.8834 29.6151 10.8217 29.6088 10.7627C29.6034 10.7105 29.5869 10.6601 29.5607 10.6145C29.531 10.5632 29.4842 10.5209 29.3906 10.4365L26.8671 8.1624C26.5503 7.87687 26.3919 7.73415 26.3722 7.60065C26.3551 7.48467 26.3932 7.36737 26.4752 7.2836C26.5696 7.18716 26.7817 7.16478 27.2058 7.12002L30.584 6.76346C30.7094 6.75023 30.7721 6.74362 30.8263 6.71947C30.8742 6.69811 30.9172 6.6669 30.9523 6.62788C30.9921 6.58379 31.0177 6.52622 31.0691 6.41106L32.4521 3.30836Z"
                                      fill="#FFC300"
                                      stroke="#FFC300"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M56.4521 3.30836C56.6257 2.91883 56.7125 2.72406 56.8334 2.66408C56.9384 2.61197 57.0617 2.61197 57.1667 2.66408C57.2876 2.72406 57.3745 2.91883 57.5481 3.30836L58.9311 6.41106C58.9825 6.52622 59.0081 6.58379 59.0479 6.62788C59.083 6.6669 59.126 6.69811 59.1739 6.71947C59.2281 6.74362 59.2908 6.75023 59.4162 6.76346L62.7944 7.12002C63.2186 7.16478 63.4306 7.18716 63.525 7.2836C63.607 7.36737 63.6451 7.48467 63.628 7.60065C63.6083 7.73415 63.4499 7.87687 63.1331 8.1624L60.6096 10.4365C60.516 10.5209 60.4691 10.5632 60.4395 10.6145C60.4133 10.6601 60.3968 10.7105 60.3914 10.7627C60.3851 10.8217 60.3982 10.8834 60.4244 11.0068L61.1292 14.3298C61.2177 14.747 61.262 14.9556 61.1994 15.0752C61.145 15.1791 61.0453 15.2515 60.9297 15.2711C60.7967 15.2936 60.6119 15.1871 60.2425 14.9741L57.2999 13.2768C57.1907 13.2138 57.1361 13.1824 57.078 13.17C57.0266 13.1591 56.9735 13.1591 56.9222 13.17C56.8641 13.1824 56.8095 13.2138 56.7003 13.2768L53.7577 14.9741C53.3883 15.1871 53.2036 15.2936 53.0705 15.2711C52.9549 15.2515 52.8551 15.1791 52.8008 15.0752C52.7383 14.9556 52.7825 14.747 52.871 14.3298L53.5758 11.0068C53.602 10.8834 53.6151 10.8217 53.6088 10.7627C53.6034 10.7105 53.5869 10.6601 53.5607 10.6145C53.531 10.5632 53.4842 10.5209 53.3906 10.4365L50.8671 8.1624C50.5503 7.87687 50.3919 7.73415 50.3722 7.60065C50.3551 7.48467 50.3932 7.36737 50.4752 7.2836C50.5696 7.18716 50.7817 7.16478 51.2058 7.12002L54.584 6.76346C54.7094 6.75023 54.7721 6.74362 54.8263 6.71947C54.8742 6.69811 54.9172 6.6669 54.9523 6.62788C54.9921 6.58379 55.0177 6.52622 55.0691 6.41106L56.4521 3.30836Z"
                                      fill="#FFC300"
                                      stroke="#FFC300"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M80.4521 3.30836C80.6257 2.91883 80.7125 2.72406 80.8334 2.66408C80.9384 2.61197 81.0617 2.61197 81.1667 2.66408C81.2876 2.72406 81.3745 2.91883 81.5481 3.30836L82.9311 6.41106C82.9825 6.52622 83.0081 6.58379 83.0479 6.62788C83.083 6.6669 83.126 6.69811 83.1739 6.71947C83.2281 6.74362 83.2908 6.75023 83.4162 6.76346L86.7944 7.12002C87.2186 7.16478 87.4306 7.18716 87.525 7.2836C87.607 7.36737 87.6451 7.48467 87.628 7.60065C87.6083 7.73415 87.4499 7.87687 87.1331 8.1624L84.6096 10.4365C84.516 10.5209 84.4691 10.5632 84.4395 10.6145C84.4133 10.6601 84.3968 10.7105 84.3914 10.7627C84.3851 10.8217 84.3982 10.8834 84.4244 11.0068L85.1292 14.3298C85.2177 14.747 85.262 14.9556 85.1994 15.0752C85.145 15.1791 85.0453 15.2515 84.9297 15.2711C84.7967 15.2936 84.6119 15.1871 84.2425 14.9741L81.2999 13.2768C81.1907 13.2138 81.1361 13.1824 81.078 13.17C81.0266 13.1591 80.9735 13.1591 80.9222 13.17C80.8641 13.1824 80.8095 13.2138 80.7003 13.2768L77.7577 14.9741C77.3883 15.1871 77.2036 15.2936 77.0705 15.2711C76.9549 15.2515 76.8551 15.1791 76.8008 15.0752C76.7383 14.9556 76.7825 14.747 76.871 14.3298L77.5758 11.0068C77.602 10.8834 77.6151 10.8217 77.6088 10.7627C77.6034 10.7105 77.5869 10.6601 77.5607 10.6145C77.531 10.5632 77.4842 10.5209 77.3906 10.4365L74.8671 8.1624C74.5503 7.87687 74.3919 7.73415 74.3722 7.60065C74.3551 7.48467 74.3932 7.36737 74.4752 7.2836C74.5696 7.18716 74.7817 7.16478 75.2058 7.12002L78.584 6.76346C78.7094 6.75023 78.7721 6.74362 78.8263 6.71947C78.8742 6.69811 78.9172 6.6669 78.9523 6.62788C78.9921 6.58379 79.0177 6.52622 79.0691 6.41106L80.4521 3.30836Z"
                                      fill="#FFC300"
                                      stroke="#FFC300"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M104.452 3.30836C104.626 2.91883 104.713 2.72406 104.833 2.66408C104.938 2.61197 105.062 2.61197 105.167 2.66408C105.288 2.72406 105.374 2.91883 105.548 3.30836L106.931 6.41106C106.982 6.52622 107.008 6.58379 107.048 6.62789C107.083 6.6669 107.126 6.69811 107.174 6.71947C107.228 6.74362 107.291 6.75023 107.416 6.76346L110.794 7.12002C111.219 7.16478 111.431 7.18716 111.525 7.2836C111.607 7.36737 111.645 7.48467 111.628 7.60065C111.608 7.73415 111.45 7.87687 111.133 8.1624L108.61 10.4365C108.516 10.5209 108.469 10.5632 108.44 10.6145C108.413 10.6601 108.397 10.7105 108.391 10.7627C108.385 10.8217 108.398 10.8834 108.424 11.0068L109.129 14.3298C109.218 14.747 109.262 14.9556 109.199 15.0752C109.145 15.1791 109.045 15.2515 108.93 15.2711C108.797 15.2936 108.612 15.1871 108.242 14.9741L105.3 13.2768C105.191 13.2138 105.136 13.1824 105.078 13.17C105.027 13.1591 104.974 13.1591 104.922 13.17C104.864 13.1824 104.81 13.2138 104.7 13.2768L101.758 14.9741C101.388 15.1871 101.204 15.2936 101.07 15.2711C100.955 15.2515 100.855 15.1791 100.801 15.0752C100.738 14.9556 100.783 14.747 100.871 14.3298L101.576 11.0068C101.602 10.8834 101.615 10.8217 101.609 10.7627C101.603 10.7105 101.587 10.6601 101.561 10.6145C101.531 10.5632 101.484 10.5209 101.391 10.4365L98.8671 8.1624C98.5503 7.87687 98.3919 7.73415 98.3722 7.60065C98.3551 7.48467 98.3932 7.36737 98.4752 7.2836C98.5696 7.18716 98.7817 7.16478 99.2058 7.12002L102.584 6.76346C102.709 6.75023 102.772 6.74362 102.826 6.71947C102.874 6.69811 102.917 6.6669 102.952 6.62789C102.992 6.58379 103.018 6.52622 103.069 6.41106L104.452 3.30836Z"
                                      stroke="#FFC300"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </div>
                                <div className="text-end">
                                  <p className="client-designation">Owner</p>
                                  <p className="post-time">6 months ago</p>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="card-body">
                            <h5 className="client-answer-heading">
                              Excellent in this price
                            </h5>
                            <p className="client-answer-p">
                              Street lights is working, roads quality goods,
                              night time safe environment, public transportation
                              available. Big mall not near but manageable,
                              schools and hospitals not so much close but no
                              longer distance likely
                            </p>
                          </div>

                          <div className="card-footer">
                            <div className="d-flex justify-content-end gap-2">
                              <button className="btn fake-report-btn">
                                <svg
                                  width="15"
                                  height="15"
                                  viewBox="0 0 15 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.5 11.25C7.84518 11.25 8.125 10.9702 8.125 10.625C8.125 10.2798 7.84518 10 7.5 10C7.15482 10 6.875 10.2798 6.875 10.625C6.875 10.9702 7.15482 11.25 7.5 11.25Z"
                                    fill="black"
                                  />
                                  <path
                                    d="M7.5 6.25V8.75"
                                    stroke="black"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M2.15458 11.3158L6.382 2.8609C6.84269 1.93959 8.15744 1.9396 8.61813 2.8609L12.8456 11.3158C13.2611 12.147 12.6568 13.1248 11.7275 13.1248H3.27261C2.34338 13.1248 1.73901 12.147 2.15458 11.3158Z"
                                    stroke="black"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                                Report Fake
                              </button>
                              <button className="btn help-report-btn">
                                <svg
                                  width="15"
                                  height="15"
                                  viewBox="0 0 15 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M1.875 6.39637L2.34201 6.356C2.32038 6.1059 2.10558 5.91723 1.85479 5.92806C1.604 5.93888 1.40625 6.14535 1.40625 6.39637H1.875ZM12.6476 7.53587L12.2066 10.0857L13.1304 10.2455L13.5714 7.69562L12.6476 7.53587ZM8.27812 13.2812H5.37272V14.2187H8.27812V13.2812ZM4.80311 12.7578L4.29551 6.88737L3.3615 6.96812L3.8691 12.8386L4.80311 12.7578ZM12.2066 10.0857C11.8899 11.9173 10.2383 13.2812 8.27812 13.2812V14.2187C10.6695 14.2187 12.7317 12.5506 13.1304 10.2455L12.2066 10.0857ZM8.28425 3.18759L7.87006 5.71545L8.79525 5.86703L9.20944 3.33918L8.28425 3.18759ZM4.49233 6.4035L5.39154 5.62865L4.77956 4.91846L3.88034 5.69333L4.49233 6.4035ZM7.0275 3.10753L7.32481 1.96138L6.41738 1.72598L6.12005 2.87213L7.0275 3.10753ZM7.77388 1.7365L7.8645 1.76561L8.15125 0.873041L8.06063 0.843934L7.77388 1.7365ZM6.57719 4.25999C6.77213 3.89498 6.92356 3.50837 7.0275 3.10753L6.12005 2.87213C6.03483 3.20067 5.91062 3.51808 5.75026 3.81827L6.57719 4.25999ZM7.8645 1.76561C8.056 1.82713 8.192 1.97505 8.23669 2.1474L9.14419 1.912C9.01575 1.41699 8.63687 1.02905 8.15125 0.873041L7.8645 1.76561ZM7.32481 1.96138C7.34675 1.877 7.40769 1.79945 7.49988 1.75502L7.09288 0.910466C6.76038 1.07068 6.51063 1.36642 6.41738 1.72598L7.32481 1.96138ZM7.49988 1.75502C7.58406 1.71444 7.68319 1.70738 7.77388 1.7365L8.06063 0.843934C7.74206 0.74159 7.3945 0.765122 7.09288 0.910466L7.49988 1.75502ZM8.84606 6.86512H12.0843V5.92762H8.84606V6.86512ZM2.94926 13.3788L2.34201 6.356L1.40799 6.43675L2.01524 13.4596L2.94926 13.3788ZM2.34375 13.4454V6.39637H1.40625V13.4454H2.34375ZM2.01524 13.4596C2.007 13.3642 2.08216 13.2812 2.17919 13.2812V14.2187C2.63293 14.2187 2.98826 13.8299 2.94926 13.3788L2.01524 13.4596ZM9.20944 3.33918C9.28725 2.8641 9.26506 2.37798 9.14419 1.912L8.23669 2.1474C8.32481 2.48702 8.341 2.84132 8.28425 3.18759L9.20944 3.33918ZM5.37272 13.2812C5.07652 13.2812 4.82876 13.0544 4.80311 12.7578L3.8691 12.8386C3.93657 13.6189 4.58919 14.2187 5.37272 14.2187V13.2812ZM5.39154 5.62865C5.81645 5.2625 6.2745 4.82666 6.57719 4.25999L5.75026 3.81827C5.53378 4.22354 5.18906 4.56558 4.77956 4.91846L5.39154 5.62865ZM13.5714 7.69562C13.7309 6.77281 13.0213 5.92762 12.0843 5.92762V6.86512C12.4384 6.86512 12.7082 7.18493 12.6476 7.53587L13.5714 7.69562ZM2.17919 13.2812C2.27058 13.2812 2.34375 13.3552 2.34375 13.4454H1.40625C1.40625 13.8721 1.75181 14.2187 2.17919 14.2187V13.2812ZM7.87006 5.71545C7.7715 6.31725 8.23537 6.86512 8.84606 6.86512V5.92762C8.81488 5.92762 8.78994 5.89938 8.79525 5.86703L7.87006 5.71545ZM4.29551 6.88737C4.27962 6.70362 4.35297 6.52362 4.49233 6.4035L3.88034 5.69333C3.51264 6.01019 3.31968 6.48456 3.3615 6.96812L4.29551 6.88737Z"
                                    fill="#343434"
                                  />
                                </svg>
                                Helpful
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="carousel-item">
                        <div className="card1">
                          <div className="card-header">
                            <div className="d-flex align-items-center gap-3">
                              <img
                                src={seller}
                                className="review-crousel-img"
                                alt="DreamSakha"
                              />
                              <div className="d-flex justify-content-between w-100 lh-1">
                                <div>
                                  <p className="client-name">Lakshman Singh</p>
                                  <svg
                                    width="114"
                                    height="18"
                                    viewBox="0 0 114 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.45207 3.30836C8.6257 2.91883 8.71254 2.72406 8.83345 2.66408C8.93845 2.61197 9.06175 2.61197 9.16675 2.66408C9.28764 2.72406 9.3745 2.91883 9.54812 3.30836L10.9311 6.41106C10.9825 6.52622 11.0081 6.58379 11.0479 6.62789C11.083 6.6669 11.126 6.69811 11.1739 6.71947C11.2281 6.74362 11.2908 6.75023 11.4162 6.76346L14.7944 7.12002C15.2186 7.16478 15.4306 7.18716 15.525 7.2836C15.607 7.36737 15.6451 7.48467 15.628 7.60065C15.6083 7.73415 15.4499 7.87688 15.1331 8.1624L12.6096 10.4366C12.516 10.5209 12.4691 10.5632 12.4395 10.6145C12.4133 10.6601 12.3968 10.7105 12.3914 10.7627C12.3851 10.8218 12.3982 10.8834 12.4244 11.0068L13.1292 14.3298C13.2177 14.747 13.262 14.9556 13.1994 15.0752C13.145 15.1791 13.0453 15.2516 12.9297 15.2711C12.7967 15.2936 12.6119 15.1871 12.2425 14.9741L9.29987 13.2768C9.19067 13.2138 9.13607 13.1824 9.07802 13.17C9.02664 13.1591 8.97354 13.1591 8.92217 13.17C8.86412 13.1824 8.80952 13.2138 8.70032 13.2768L5.75771 14.9741C5.38827 15.1871 5.20356 15.2936 5.0705 15.2711C4.95492 15.2516 4.85514 15.1791 4.80081 15.0752C4.73826 14.9556 4.78251 14.747 4.871 14.3298L5.57582 11.0068C5.60198 10.8834 5.61506 10.8218 5.60885 10.7627C5.60335 10.7105 5.58695 10.6601 5.5607 10.6145C5.53104 10.5632 5.48421 10.5209 5.39055 10.4366L2.86709 8.1624C2.55028 7.87688 2.39187 7.73415 2.37218 7.60065C2.35508 7.48467 2.39319 7.36737 2.47519 7.2836C2.5696 7.18716 2.78166 7.16478 3.20579 7.12002L6.58401 6.76346C6.70939 6.75023 6.77208 6.74362 6.82629 6.71947C6.87425 6.69811 6.91719 6.6669 6.95234 6.62789C6.99205 6.58379 7.01772 6.52622 7.06905 6.41106L8.45207 3.30836Z"
                                      fill="#FFC400"
                                      stroke="#FFC300"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M32.4521 3.30836C32.6257 2.91883 32.7125 2.72406 32.8334 2.66408C32.9384 2.61197 33.0617 2.61197 33.1667 2.66408C33.2876 2.72406 33.3745 2.91883 33.5481 3.30836L34.9311 6.41106C34.9825 6.52622 35.0081 6.58379 35.0479 6.62788C35.083 6.6669 35.126 6.69811 35.1739 6.71947C35.2281 6.74362 35.2908 6.75023 35.4162 6.76346L38.7944 7.12002C39.2186 7.16478 39.4306 7.18716 39.525 7.2836C39.607 7.36737 39.6451 7.48467 39.628 7.60065C39.6083 7.73415 39.4499 7.87687 39.1331 8.1624L36.6096 10.4365C36.516 10.5209 36.4691 10.5632 36.4395 10.6145C36.4133 10.6601 36.3968 10.7105 36.3914 10.7627C36.3851 10.8217 36.3982 10.8834 36.4244 11.0068L37.1292 14.3298C37.2177 14.747 37.262 14.9556 37.1994 15.0752C37.145 15.1791 37.0453 15.2515 36.9297 15.2711C36.7967 15.2936 36.6119 15.1871 36.2425 14.9741L33.2999 13.2768C33.1907 13.2138 33.1361 13.1824 33.078 13.17C33.0266 13.1591 32.9735 13.1591 32.9222 13.17C32.8641 13.1824 32.8095 13.2138 32.7003 13.2768L29.7577 14.9741C29.3883 15.1871 29.2036 15.2936 29.0705 15.2711C28.9549 15.2515 28.8551 15.1791 28.8008 15.0752C28.7383 14.9556 28.7825 14.747 28.871 14.3298L29.5758 11.0068C29.602 10.8834 29.6151 10.8217 29.6088 10.7627C29.6034 10.7105 29.5869 10.6601 29.5607 10.6145C29.531 10.5632 29.4842 10.5209 29.3906 10.4365L26.8671 8.1624C26.5503 7.87687 26.3919 7.73415 26.3722 7.60065C26.3551 7.48467 26.3932 7.36737 26.4752 7.2836C26.5696 7.18716 26.7817 7.16478 27.2058 7.12002L30.584 6.76346C30.7094 6.75023 30.7721 6.74362 30.8263 6.71947C30.8742 6.69811 30.9172 6.6669 30.9523 6.62788C30.9921 6.58379 31.0177 6.52622 31.0691 6.41106L32.4521 3.30836Z"
                                      fill="#FFC300"
                                      stroke="#FFC300"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M56.4521 3.30836C56.6257 2.91883 56.7125 2.72406 56.8334 2.66408C56.9384 2.61197 57.0617 2.61197 57.1667 2.66408C57.2876 2.72406 57.3745 2.91883 57.5481 3.30836L58.9311 6.41106C58.9825 6.52622 59.0081 6.58379 59.0479 6.62788C59.083 6.6669 59.126 6.69811 59.1739 6.71947C59.2281 6.74362 59.2908 6.75023 59.4162 6.76346L62.7944 7.12002C63.2186 7.16478 63.4306 7.18716 63.525 7.2836C63.607 7.36737 63.6451 7.48467 63.628 7.60065C63.6083 7.73415 63.4499 7.87687 63.1331 8.1624L60.6096 10.4365C60.516 10.5209 60.4691 10.5632 60.4395 10.6145C60.4133 10.6601 60.3968 10.7105 60.3914 10.7627C60.3851 10.8217 60.3982 10.8834 60.4244 11.0068L61.1292 14.3298C61.2177 14.747 61.262 14.9556 61.1994 15.0752C61.145 15.1791 61.0453 15.2515 60.9297 15.2711C60.7967 15.2936 60.6119 15.1871 60.2425 14.9741L57.2999 13.2768C57.1907 13.2138 57.1361 13.1824 57.078 13.17C57.0266 13.1591 56.9735 13.1591 56.9222 13.17C56.8641 13.1824 56.8095 13.2138 56.7003 13.2768L53.7577 14.9741C53.3883 15.1871 53.2036 15.2936 53.0705 15.2711C52.9549 15.2515 52.8551 15.1791 52.8008 15.0752C52.7383 14.9556 52.7825 14.747 52.871 14.3298L53.5758 11.0068C53.602 10.8834 53.6151 10.8217 53.6088 10.7627C53.6034 10.7105 53.5869 10.6601 53.5607 10.6145C53.531 10.5632 53.4842 10.5209 53.3906 10.4365L50.8671 8.1624C50.5503 7.87687 50.3919 7.73415 50.3722 7.60065C50.3551 7.48467 50.3932 7.36737 50.4752 7.2836C50.5696 7.18716 50.7817 7.16478 51.2058 7.12002L54.584 6.76346C54.7094 6.75023 54.7721 6.74362 54.8263 6.71947C54.8742 6.69811 54.9172 6.6669 54.9523 6.62788C54.9921 6.58379 55.0177 6.52622 55.0691 6.41106L56.4521 3.30836Z"
                                      fill="#FFC300"
                                      stroke="#FFC300"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M80.4521 3.30836C80.6257 2.91883 80.7125 2.72406 80.8334 2.66408C80.9384 2.61197 81.0617 2.61197 81.1667 2.66408C81.2876 2.72406 81.3745 2.91883 81.5481 3.30836L82.9311 6.41106C82.9825 6.52622 83.0081 6.58379 83.0479 6.62788C83.083 6.6669 83.126 6.69811 83.1739 6.71947C83.2281 6.74362 83.2908 6.75023 83.4162 6.76346L86.7944 7.12002C87.2186 7.16478 87.4306 7.18716 87.525 7.2836C87.607 7.36737 87.6451 7.48467 87.628 7.60065C87.6083 7.73415 87.4499 7.87687 87.1331 8.1624L84.6096 10.4365C84.516 10.5209 84.4691 10.5632 84.4395 10.6145C84.4133 10.6601 84.3968 10.7105 84.3914 10.7627C84.3851 10.8217 84.3982 10.8834 84.4244 11.0068L85.1292 14.3298C85.2177 14.747 85.262 14.9556 85.1994 15.0752C85.145 15.1791 85.0453 15.2515 84.9297 15.2711C84.7967 15.2936 84.6119 15.1871 84.2425 14.9741L81.2999 13.2768C81.1907 13.2138 81.1361 13.1824 81.078 13.17C81.0266 13.1591 80.9735 13.1591 80.9222 13.17C80.8641 13.1824 80.8095 13.2138 80.7003 13.2768L77.7577 14.9741C77.3883 15.1871 77.2036 15.2936 77.0705 15.2711C76.9549 15.2515 76.8551 15.1791 76.8008 15.0752C76.7383 14.9556 76.7825 14.747 76.871 14.3298L77.5758 11.0068C77.602 10.8834 77.6151 10.8217 77.6088 10.7627C77.6034 10.7105 77.5869 10.6601 77.5607 10.6145C77.531 10.5632 77.4842 10.5209 77.3906 10.4365L74.8671 8.1624C74.5503 7.87687 74.3919 7.73415 74.3722 7.60065C74.3551 7.48467 74.3932 7.36737 74.4752 7.2836C74.5696 7.18716 74.7817 7.16478 75.2058 7.12002L78.584 6.76346C78.7094 6.75023 78.7721 6.74362 78.8263 6.71947C78.8742 6.69811 78.9172 6.6669 78.9523 6.62788C78.9921 6.58379 79.0177 6.52622 79.0691 6.41106L80.4521 3.30836Z"
                                      fill="#FFC300"
                                      stroke="#FFC300"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M104.452 3.30836C104.626 2.91883 104.713 2.72406 104.833 2.66408C104.938 2.61197 105.062 2.61197 105.167 2.66408C105.288 2.72406 105.374 2.91883 105.548 3.30836L106.931 6.41106C106.982 6.52622 107.008 6.58379 107.048 6.62789C107.083 6.6669 107.126 6.69811 107.174 6.71947C107.228 6.74362 107.291 6.75023 107.416 6.76346L110.794 7.12002C111.219 7.16478 111.431 7.18716 111.525 7.2836C111.607 7.36737 111.645 7.48467 111.628 7.60065C111.608 7.73415 111.45 7.87687 111.133 8.1624L108.61 10.4365C108.516 10.5209 108.469 10.5632 108.44 10.6145C108.413 10.6601 108.397 10.7105 108.391 10.7627C108.385 10.8217 108.398 10.8834 108.424 11.0068L109.129 14.3298C109.218 14.747 109.262 14.9556 109.199 15.0752C109.145 15.1791 109.045 15.2515 108.93 15.2711C108.797 15.2936 108.612 15.1871 108.242 14.9741L105.3 13.2768C105.191 13.2138 105.136 13.1824 105.078 13.17C105.027 13.1591 104.974 13.1591 104.922 13.17C104.864 13.1824 104.81 13.2138 104.7 13.2768L101.758 14.9741C101.388 15.1871 101.204 15.2936 101.07 15.2711C100.955 15.2515 100.855 15.1791 100.801 15.0752C100.738 14.9556 100.783 14.747 100.871 14.3298L101.576 11.0068C101.602 10.8834 101.615 10.8217 101.609 10.7627C101.603 10.7105 101.587 10.6601 101.561 10.6145C101.531 10.5632 101.484 10.5209 101.391 10.4365L98.8671 8.1624C98.5503 7.87687 98.3919 7.73415 98.3722 7.60065C98.3551 7.48467 98.3932 7.36737 98.4752 7.2836C98.5696 7.18716 98.7817 7.16478 99.2058 7.12002L102.584 6.76346C102.709 6.75023 102.772 6.74362 102.826 6.71947C102.874 6.69811 102.917 6.6669 102.952 6.62789C102.992 6.58379 103.018 6.52622 103.069 6.41106L104.452 3.30836Z"
                                      stroke="#FFC300"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </div>
                                <div className="text-end">
                                  <p className="client-designation">Owner</p>
                                  <p className="post-time">6 months ago</p>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="card-body">
                            <h5 className="client-answer-heading">
                              Excellent in this price
                            </h5>
                            <p className="client-answer-p">
                              Street lights is working, roads quality goods,
                              night time safe environment, public transportation
                              available. Big mall not near but manageable,
                              schools and hospitals not so much close but no
                              longer distance likely
                            </p>
                          </div>

                          <div className="card-footer">
                            <div className="d-flex justify-content-end gap-2">
                              <button className="btn fake-report-btn">
                                <svg
                                  width="15"
                                  height="15"
                                  viewBox="0 0 15 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.5 11.25C7.84518 11.25 8.125 10.9702 8.125 10.625C8.125 10.2798 7.84518 10 7.5 10C7.15482 10 6.875 10.2798 6.875 10.625C6.875 10.9702 7.15482 11.25 7.5 11.25Z"
                                    fill="black"
                                  />
                                  <path
                                    d="M7.5 6.25V8.75"
                                    stroke="black"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M2.15458 11.3158L6.382 2.8609C6.84269 1.93959 8.15744 1.9396 8.61813 2.8609L12.8456 11.3158C13.2611 12.147 12.6568 13.1248 11.7275 13.1248H3.27261C2.34338 13.1248 1.73901 12.147 2.15458 11.3158Z"
                                    stroke="black"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                                Report Fake
                              </button>
                              <button className="btn help-report-btn">
                                <svg
                                  width="15"
                                  height="15"
                                  viewBox="0 0 15 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M1.875 6.39637L2.34201 6.356C2.32038 6.1059 2.10558 5.91723 1.85479 5.92806C1.604 5.93888 1.40625 6.14535 1.40625 6.39637H1.875ZM12.6476 7.53587L12.2066 10.0857L13.1304 10.2455L13.5714 7.69562L12.6476 7.53587ZM8.27812 13.2812H5.37272V14.2187H8.27812V13.2812ZM4.80311 12.7578L4.29551 6.88737L3.3615 6.96812L3.8691 12.8386L4.80311 12.7578ZM12.2066 10.0857C11.8899 11.9173 10.2383 13.2812 8.27812 13.2812V14.2187C10.6695 14.2187 12.7317 12.5506 13.1304 10.2455L12.2066 10.0857ZM8.28425 3.18759L7.87006 5.71545L8.79525 5.86703L9.20944 3.33918L8.28425 3.18759ZM4.49233 6.4035L5.39154 5.62865L4.77956 4.91846L3.88034 5.69333L4.49233 6.4035ZM7.0275 3.10753L7.32481 1.96138L6.41738 1.72598L6.12005 2.87213L7.0275 3.10753ZM7.77388 1.7365L7.8645 1.76561L8.15125 0.873041L8.06063 0.843934L7.77388 1.7365ZM6.57719 4.25999C6.77213 3.89498 6.92356 3.50837 7.0275 3.10753L6.12005 2.87213C6.03483 3.20067 5.91062 3.51808 5.75026 3.81827L6.57719 4.25999ZM7.8645 1.76561C8.056 1.82713 8.192 1.97505 8.23669 2.1474L9.14419 1.912C9.01575 1.41699 8.63687 1.02905 8.15125 0.873041L7.8645 1.76561ZM7.32481 1.96138C7.34675 1.877 7.40769 1.79945 7.49988 1.75502L7.09288 0.910466C6.76038 1.07068 6.51063 1.36642 6.41738 1.72598L7.32481 1.96138ZM7.49988 1.75502C7.58406 1.71444 7.68319 1.70738 7.77388 1.7365L8.06063 0.843934C7.74206 0.74159 7.3945 0.765122 7.09288 0.910466L7.49988 1.75502ZM8.84606 6.86512H12.0843V5.92762H8.84606V6.86512ZM2.94926 13.3788L2.34201 6.356L1.40799 6.43675L2.01524 13.4596L2.94926 13.3788ZM2.34375 13.4454V6.39637H1.40625V13.4454H2.34375ZM2.01524 13.4596C2.007 13.3642 2.08216 13.2812 2.17919 13.2812V14.2187C2.63293 14.2187 2.98826 13.8299 2.94926 13.3788L2.01524 13.4596ZM9.20944 3.33918C9.28725 2.8641 9.26506 2.37798 9.14419 1.912L8.23669 2.1474C8.32481 2.48702 8.341 2.84132 8.28425 3.18759L9.20944 3.33918ZM5.37272 13.2812C5.07652 13.2812 4.82876 13.0544 4.80311 12.7578L3.8691 12.8386C3.93657 13.6189 4.58919 14.2187 5.37272 14.2187V13.2812ZM5.39154 5.62865C5.81645 5.2625 6.2745 4.82666 6.57719 4.25999L5.75026 3.81827C5.53378 4.22354 5.18906 4.56558 4.77956 4.91846L5.39154 5.62865ZM13.5714 7.69562C13.7309 6.77281 13.0213 5.92762 12.0843 5.92762V6.86512C12.4384 6.86512 12.7082 7.18493 12.6476 7.53587L13.5714 7.69562ZM2.17919 13.2812C2.27058 13.2812 2.34375 13.3552 2.34375 13.4454H1.40625C1.40625 13.8721 1.75181 14.2187 2.17919 14.2187V13.2812ZM7.87006 5.71545C7.7715 6.31725 8.23537 6.86512 8.84606 6.86512V5.92762C8.81488 5.92762 8.78994 5.89938 8.79525 5.86703L7.87006 5.71545ZM4.29551 6.88737C4.27962 6.70362 4.35297 6.52362 4.49233 6.4035L3.88034 5.69333C3.51264 6.01019 3.31968 6.48456 3.3615 6.96812L4.29551 6.88737Z"
                                    fill="#343434"
                                  />
                                </svg>
                                Helpful
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="carousel-item">
                        <div className="card1">
                          <div className="card-header">
                            <div className="d-flex align-items-center gap-3">
                              <img
                                src={seller}
                                className="review-crousel-img"
                                alt="DreamSakha"
                              />
                              <div className="d-flex justify-content-between w-100 lh-1">
                                <div>
                                  <p className="client-name">Lakshman Singh</p>
                                  <svg
                                    width="114"
                                    height="18"
                                    viewBox="0 0 114 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.45207 3.30836C8.6257 2.91883 8.71254 2.72406 8.83345 2.66408C8.93845 2.61197 9.06175 2.61197 9.16675 2.66408C9.28764 2.72406 9.3745 2.91883 9.54812 3.30836L10.9311 6.41106C10.9825 6.52622 11.0081 6.58379 11.0479 6.62789C11.083 6.6669 11.126 6.69811 11.1739 6.71947C11.2281 6.74362 11.2908 6.75023 11.4162 6.76346L14.7944 7.12002C15.2186 7.16478 15.4306 7.18716 15.525 7.2836C15.607 7.36737 15.6451 7.48467 15.628 7.60065C15.6083 7.73415 15.4499 7.87688 15.1331 8.1624L12.6096 10.4366C12.516 10.5209 12.4691 10.5632 12.4395 10.6145C12.4133 10.6601 12.3968 10.7105 12.3914 10.7627C12.3851 10.8218 12.3982 10.8834 12.4244 11.0068L13.1292 14.3298C13.2177 14.747 13.262 14.9556 13.1994 15.0752C13.145 15.1791 13.0453 15.2516 12.9297 15.2711C12.7967 15.2936 12.6119 15.1871 12.2425 14.9741L9.29987 13.2768C9.19067 13.2138 9.13607 13.1824 9.07802 13.17C9.02664 13.1591 8.97354 13.1591 8.92217 13.17C8.86412 13.1824 8.80952 13.2138 8.70032 13.2768L5.75771 14.9741C5.38827 15.1871 5.20356 15.2936 5.0705 15.2711C4.95492 15.2516 4.85514 15.1791 4.80081 15.0752C4.73826 14.9556 4.78251 14.747 4.871 14.3298L5.57582 11.0068C5.60198 10.8834 5.61506 10.8218 5.60885 10.7627C5.60335 10.7105 5.58695 10.6601 5.5607 10.6145C5.53104 10.5632 5.48421 10.5209 5.39055 10.4366L2.86709 8.1624C2.55028 7.87688 2.39187 7.73415 2.37218 7.60065C2.35508 7.48467 2.39319 7.36737 2.47519 7.2836C2.5696 7.18716 2.78166 7.16478 3.20579 7.12002L6.58401 6.76346C6.70939 6.75023 6.77208 6.74362 6.82629 6.71947C6.87425 6.69811 6.91719 6.6669 6.95234 6.62789C6.99205 6.58379 7.01772 6.52622 7.06905 6.41106L8.45207 3.30836Z"
                                      fill="#FFC400"
                                      stroke="#FFC300"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M32.4521 3.30836C32.6257 2.91883 32.7125 2.72406 32.8334 2.66408C32.9384 2.61197 33.0617 2.61197 33.1667 2.66408C33.2876 2.72406 33.3745 2.91883 33.5481 3.30836L34.9311 6.41106C34.9825 6.52622 35.0081 6.58379 35.0479 6.62788C35.083 6.6669 35.126 6.69811 35.1739 6.71947C35.2281 6.74362 35.2908 6.75023 35.4162 6.76346L38.7944 7.12002C39.2186 7.16478 39.4306 7.18716 39.525 7.2836C39.607 7.36737 39.6451 7.48467 39.628 7.60065C39.6083 7.73415 39.4499 7.87687 39.1331 8.1624L36.6096 10.4365C36.516 10.5209 36.4691 10.5632 36.4395 10.6145C36.4133 10.6601 36.3968 10.7105 36.3914 10.7627C36.3851 10.8217 36.3982 10.8834 36.4244 11.0068L37.1292 14.3298C37.2177 14.747 37.262 14.9556 37.1994 15.0752C37.145 15.1791 37.0453 15.2515 36.9297 15.2711C36.7967 15.2936 36.6119 15.1871 36.2425 14.9741L33.2999 13.2768C33.1907 13.2138 33.1361 13.1824 33.078 13.17C33.0266 13.1591 32.9735 13.1591 32.9222 13.17C32.8641 13.1824 32.8095 13.2138 32.7003 13.2768L29.7577 14.9741C29.3883 15.1871 29.2036 15.2936 29.0705 15.2711C28.9549 15.2515 28.8551 15.1791 28.8008 15.0752C28.7383 14.9556 28.7825 14.747 28.871 14.3298L29.5758 11.0068C29.602 10.8834 29.6151 10.8217 29.6088 10.7627C29.6034 10.7105 29.5869 10.6601 29.5607 10.6145C29.531 10.5632 29.4842 10.5209 29.3906 10.4365L26.8671 8.1624C26.5503 7.87687 26.3919 7.73415 26.3722 7.60065C26.3551 7.48467 26.3932 7.36737 26.4752 7.2836C26.5696 7.18716 26.7817 7.16478 27.2058 7.12002L30.584 6.76346C30.7094 6.75023 30.7721 6.74362 30.8263 6.71947C30.8742 6.69811 30.9172 6.6669 30.9523 6.62788C30.9921 6.58379 31.0177 6.52622 31.0691 6.41106L32.4521 3.30836Z"
                                      fill="#FFC300"
                                      stroke="#FFC300"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M56.4521 3.30836C56.6257 2.91883 56.7125 2.72406 56.8334 2.66408C56.9384 2.61197 57.0617 2.61197 57.1667 2.66408C57.2876 2.72406 57.3745 2.91883 57.5481 3.30836L58.9311 6.41106C58.9825 6.52622 59.0081 6.58379 59.0479 6.62788C59.083 6.6669 59.126 6.69811 59.1739 6.71947C59.2281 6.74362 59.2908 6.75023 59.4162 6.76346L62.7944 7.12002C63.2186 7.16478 63.4306 7.18716 63.525 7.2836C63.607 7.36737 63.6451 7.48467 63.628 7.60065C63.6083 7.73415 63.4499 7.87687 63.1331 8.1624L60.6096 10.4365C60.516 10.5209 60.4691 10.5632 60.4395 10.6145C60.4133 10.6601 60.3968 10.7105 60.3914 10.7627C60.3851 10.8217 60.3982 10.8834 60.4244 11.0068L61.1292 14.3298C61.2177 14.747 61.262 14.9556 61.1994 15.0752C61.145 15.1791 61.0453 15.2515 60.9297 15.2711C60.7967 15.2936 60.6119 15.1871 60.2425 14.9741L57.2999 13.2768C57.1907 13.2138 57.1361 13.1824 57.078 13.17C57.0266 13.1591 56.9735 13.1591 56.9222 13.17C56.8641 13.1824 56.8095 13.2138 56.7003 13.2768L53.7577 14.9741C53.3883 15.1871 53.2036 15.2936 53.0705 15.2711C52.9549 15.2515 52.8551 15.1791 52.8008 15.0752C52.7383 14.9556 52.7825 14.747 52.871 14.3298L53.5758 11.0068C53.602 10.8834 53.6151 10.8217 53.6088 10.7627C53.6034 10.7105 53.5869 10.6601 53.5607 10.6145C53.531 10.5632 53.4842 10.5209 53.3906 10.4365L50.8671 8.1624C50.5503 7.87687 50.3919 7.73415 50.3722 7.60065C50.3551 7.48467 50.3932 7.36737 50.4752 7.2836C50.5696 7.18716 50.7817 7.16478 51.2058 7.12002L54.584 6.76346C54.7094 6.75023 54.7721 6.74362 54.8263 6.71947C54.8742 6.69811 54.9172 6.6669 54.9523 6.62788C54.9921 6.58379 55.0177 6.52622 55.0691 6.41106L56.4521 3.30836Z"
                                      fill="#FFC300"
                                      stroke="#FFC300"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M80.4521 3.30836C80.6257 2.91883 80.7125 2.72406 80.8334 2.66408C80.9384 2.61197 81.0617 2.61197 81.1667 2.66408C81.2876 2.72406 81.3745 2.91883 81.5481 3.30836L82.9311 6.41106C82.9825 6.52622 83.0081 6.58379 83.0479 6.62788C83.083 6.6669 83.126 6.69811 83.1739 6.71947C83.2281 6.74362 83.2908 6.75023 83.4162 6.76346L86.7944 7.12002C87.2186 7.16478 87.4306 7.18716 87.525 7.2836C87.607 7.36737 87.6451 7.48467 87.628 7.60065C87.6083 7.73415 87.4499 7.87687 87.1331 8.1624L84.6096 10.4365C84.516 10.5209 84.4691 10.5632 84.4395 10.6145C84.4133 10.6601 84.3968 10.7105 84.3914 10.7627C84.3851 10.8217 84.3982 10.8834 84.4244 11.0068L85.1292 14.3298C85.2177 14.747 85.262 14.9556 85.1994 15.0752C85.145 15.1791 85.0453 15.2515 84.9297 15.2711C84.7967 15.2936 84.6119 15.1871 84.2425 14.9741L81.2999 13.2768C81.1907 13.2138 81.1361 13.1824 81.078 13.17C81.0266 13.1591 80.9735 13.1591 80.9222 13.17C80.8641 13.1824 80.8095 13.2138 80.7003 13.2768L77.7577 14.9741C77.3883 15.1871 77.2036 15.2936 77.0705 15.2711C76.9549 15.2515 76.8551 15.1791 76.8008 15.0752C76.7383 14.9556 76.7825 14.747 76.871 14.3298L77.5758 11.0068C77.602 10.8834 77.6151 10.8217 77.6088 10.7627C77.6034 10.7105 77.5869 10.6601 77.5607 10.6145C77.531 10.5632 77.4842 10.5209 77.3906 10.4365L74.8671 8.1624C74.5503 7.87687 74.3919 7.73415 74.3722 7.60065C74.3551 7.48467 74.3932 7.36737 74.4752 7.2836C74.5696 7.18716 74.7817 7.16478 75.2058 7.12002L78.584 6.76346C78.7094 6.75023 78.7721 6.74362 78.8263 6.71947C78.8742 6.69811 78.9172 6.6669 78.9523 6.62788C78.9921 6.58379 79.0177 6.52622 79.0691 6.41106L80.4521 3.30836Z"
                                      fill="#FFC300"
                                      stroke="#FFC300"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M104.452 3.30836C104.626 2.91883 104.713 2.72406 104.833 2.66408C104.938 2.61197 105.062 2.61197 105.167 2.66408C105.288 2.72406 105.374 2.91883 105.548 3.30836L106.931 6.41106C106.982 6.52622 107.008 6.58379 107.048 6.62789C107.083 6.6669 107.126 6.69811 107.174 6.71947C107.228 6.74362 107.291 6.75023 107.416 6.76346L110.794 7.12002C111.219 7.16478 111.431 7.18716 111.525 7.2836C111.607 7.36737 111.645 7.48467 111.628 7.60065C111.608 7.73415 111.45 7.87687 111.133 8.1624L108.61 10.4365C108.516 10.5209 108.469 10.5632 108.44 10.6145C108.413 10.6601 108.397 10.7105 108.391 10.7627C108.385 10.8217 108.398 10.8834 108.424 11.0068L109.129 14.3298C109.218 14.747 109.262 14.9556 109.199 15.0752C109.145 15.1791 109.045 15.2515 108.93 15.2711C108.797 15.2936 108.612 15.1871 108.242 14.9741L105.3 13.2768C105.191 13.2138 105.136 13.1824 105.078 13.17C105.027 13.1591 104.974 13.1591 104.922 13.17C104.864 13.1824 104.81 13.2138 104.7 13.2768L101.758 14.9741C101.388 15.1871 101.204 15.2936 101.07 15.2711C100.955 15.2515 100.855 15.1791 100.801 15.0752C100.738 14.9556 100.783 14.747 100.871 14.3298L101.576 11.0068C101.602 10.8834 101.615 10.8217 101.609 10.7627C101.603 10.7105 101.587 10.6601 101.561 10.6145C101.531 10.5632 101.484 10.5209 101.391 10.4365L98.8671 8.1624C98.5503 7.87687 98.3919 7.73415 98.3722 7.60065C98.3551 7.48467 98.3932 7.36737 98.4752 7.2836C98.5696 7.18716 98.7817 7.16478 99.2058 7.12002L102.584 6.76346C102.709 6.75023 102.772 6.74362 102.826 6.71947C102.874 6.69811 102.917 6.6669 102.952 6.62789C102.992 6.58379 103.018 6.52622 103.069 6.41106L104.452 3.30836Z"
                                      stroke="#FFC300"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </div>
                                <div className="text-end">
                                  <p className="client-designation">Owner</p>
                                  <p className="post-time">6 months ago</p>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="card-body">
                            <h5 className="client-answer-heading">
                              Excellent in this price
                            </h5>
                            <p className="client-answer-p">
                              Street lights is working, roads quality goods,
                              night time safe environment, public transportation
                              available. Big mall not near but manageable,
                              schools and hospitals not so much close but no
                              longer distance likely
                            </p>
                          </div>

                          <div className="card-footer">
                            <div className="d-flex justify-content-end gap-2">
                              <button className="btn fake-report-btn">
                                <svg
                                  width="15"
                                  height="15"
                                  viewBox="0 0 15 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.5 11.25C7.84518 11.25 8.125 10.9702 8.125 10.625C8.125 10.2798 7.84518 10 7.5 10C7.15482 10 6.875 10.2798 6.875 10.625C6.875 10.9702 7.15482 11.25 7.5 11.25Z"
                                    fill="black"
                                  />
                                  <path
                                    d="M7.5 6.25V8.75"
                                    stroke="black"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M2.15458 11.3158L6.382 2.8609C6.84269 1.93959 8.15744 1.9396 8.61813 2.8609L12.8456 11.3158C13.2611 12.147 12.6568 13.1248 11.7275 13.1248H3.27261C2.34338 13.1248 1.73901 12.147 2.15458 11.3158Z"
                                    stroke="black"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                                Report Fake
                              </button>
                              <button className="btn help-report-btn">
                                <svg
                                  width="15"
                                  height="15"
                                  viewBox="0 0 15 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M1.875 6.39637L2.34201 6.356C2.32038 6.1059 2.10558 5.91723 1.85479 5.92806C1.604 5.93888 1.40625 6.14535 1.40625 6.39637H1.875ZM12.6476 7.53587L12.2066 10.0857L13.1304 10.2455L13.5714 7.69562L12.6476 7.53587ZM8.27812 13.2812H5.37272V14.2187H8.27812V13.2812ZM4.80311 12.7578L4.29551 6.88737L3.3615 6.96812L3.8691 12.8386L4.80311 12.7578ZM12.2066 10.0857C11.8899 11.9173 10.2383 13.2812 8.27812 13.2812V14.2187C10.6695 14.2187 12.7317 12.5506 13.1304 10.2455L12.2066 10.0857ZM8.28425 3.18759L7.87006 5.71545L8.79525 5.86703L9.20944 3.33918L8.28425 3.18759ZM4.49233 6.4035L5.39154 5.62865L4.77956 4.91846L3.88034 5.69333L4.49233 6.4035ZM7.0275 3.10753L7.32481 1.96138L6.41738 1.72598L6.12005 2.87213L7.0275 3.10753ZM7.77388 1.7365L7.8645 1.76561L8.15125 0.873041L8.06063 0.843934L7.77388 1.7365ZM6.57719 4.25999C6.77213 3.89498 6.92356 3.50837 7.0275 3.10753L6.12005 2.87213C6.03483 3.20067 5.91062 3.51808 5.75026 3.81827L6.57719 4.25999ZM7.8645 1.76561C8.056 1.82713 8.192 1.97505 8.23669 2.1474L9.14419 1.912C9.01575 1.41699 8.63687 1.02905 8.15125 0.873041L7.8645 1.76561ZM7.32481 1.96138C7.34675 1.877 7.40769 1.79945 7.49988 1.75502L7.09288 0.910466C6.76038 1.07068 6.51063 1.36642 6.41738 1.72598L7.32481 1.96138ZM7.49988 1.75502C7.58406 1.71444 7.68319 1.70738 7.77388 1.7365L8.06063 0.843934C7.74206 0.74159 7.3945 0.765122 7.09288 0.910466L7.49988 1.75502ZM8.84606 6.86512H12.0843V5.92762H8.84606V6.86512ZM2.94926 13.3788L2.34201 6.356L1.40799 6.43675L2.01524 13.4596L2.94926 13.3788ZM2.34375 13.4454V6.39637H1.40625V13.4454H2.34375ZM2.01524 13.4596C2.007 13.3642 2.08216 13.2812 2.17919 13.2812V14.2187C2.63293 14.2187 2.98826 13.8299 2.94926 13.3788L2.01524 13.4596ZM9.20944 3.33918C9.28725 2.8641 9.26506 2.37798 9.14419 1.912L8.23669 2.1474C8.32481 2.48702 8.341 2.84132 8.28425 3.18759L9.20944 3.33918ZM5.37272 13.2812C5.07652 13.2812 4.82876 13.0544 4.80311 12.7578L3.8691 12.8386C3.93657 13.6189 4.58919 14.2187 5.37272 14.2187V13.2812ZM5.39154 5.62865C5.81645 5.2625 6.2745 4.82666 6.57719 4.25999L5.75026 3.81827C5.53378 4.22354 5.18906 4.56558 4.77956 4.91846L5.39154 5.62865ZM13.5714 7.69562C13.7309 6.77281 13.0213 5.92762 12.0843 5.92762V6.86512C12.4384 6.86512 12.7082 7.18493 12.6476 7.53587L13.5714 7.69562ZM2.17919 13.2812C2.27058 13.2812 2.34375 13.3552 2.34375 13.4454H1.40625C1.40625 13.8721 1.75181 14.2187 2.17919 14.2187V13.2812ZM7.87006 5.71545C7.7715 6.31725 8.23537 6.86512 8.84606 6.86512V5.92762C8.81488 5.92762 8.78994 5.89938 8.79525 5.86703L7.87006 5.71545ZM4.29551 6.88737C4.27962 6.70362 4.35297 6.52362 4.49233 6.4035L3.88034 5.69333C3.51264 6.01019 3.31968 6.48456 3.3615 6.96812L4.29551 6.88737Z"
                                    fill="#343434"
                                  />
                                </svg>
                                Helpful
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <button
                      className="carousel-control-prev  review-prev"
                      type="button"
                      data-bs-target="#reviewCarousel"
                      data-bs-slide="prev"
                    >
                      <svg
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15 2.5C8.09625 2.5 2.5 8.09625 2.5 15C2.5 21.9037 8.09625 27.5 15 27.5C21.9037 27.5 27.5 21.9037 27.5 15C27.5 8.09625 21.9037 2.5 15 2.5Z"
                          stroke="#343434"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M16.5752 10.5871L12.1752 14.9996L16.5752 19.4121"
                          stroke="#343434"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>

                      <span className="visually-hidden">Previous</span>
                    </button>
                    <button
                      className="carousel-control-next review-next"
                      type="button"
                      data-bs-target="#reviewCarousel"
                      data-bs-slide="next"
                    >
                      <svg
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15 27.5C21.9037 27.5 27.5 21.9037 27.5 15C27.5 8.09625 21.9037 2.5 15 2.5C8.09625 2.5 2.5 8.09625 2.5 15C2.5 21.9037 8.09625 27.5 15 27.5Z"
                          stroke="#343434"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M13.4248 19.4129L17.8248 15.0004L13.4248 10.5879"
                          stroke="#343434"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>

                      <span className="visually-hidden">Next</span>
                    </button>
                    <div></div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="doughnutbox">
                    <Doughnut data={data1} options={options1} />
                  </div>
                </div>
              </div>
            </div> */}
            {list?.about_developer && list?.redirection == "pid" && (
              <div id="about-section">
                <AboutDeveloper list={list} handleShowModal={handleShowModal} />
              </div>
            )}
            {list?.faq_section && (
              <div id="faq-section">
                <PropertyFaq
                  faq={Array.isArray(list?.faq_section) ? list.faq_section : []}
                />
              </div>
            )}
            {list?.disclaimer && (
              <div id="disclaimer-section">
                <Disclaimer data={list?.disclaimer} />
              </div>
            )}
          </div>
        </div>
        {iframe && <VideoModal url={videLink} closeModal={closeModal} />}

        {showModal && (
          <ContactModal
            handleClose={() => {
              setShowModal(false);
              setContactMobile("");
            }}
            project={selectedProject}
            contactMobile={contactMobile}
            displayTitle={selectedProject?.property_title}
          />
        )}
        {showAlertModal && <AlertModal />}
      </div>
    </>
  );
};

export default PropertyDetail;
